/*
  Madison Center: cantidad del carrito con SELECCIONADOR (como Amazon: "Cant.: 1 ▾") en vez de "− 1 +".
  Pedido de Jonathan 2026-10-02. Se carga en todas las páginas desde layout/theme.liquid.

  - Se pone un <select> en lugar del selector "− 1 +" del tema, en la página del carrito y en el carrito lateral.
    No se modificó main-cart.liquid ni mini-cart.liquid.
  - Solo ofrece las unidades que HAY en inventario (pedido de Jonathan): el dato sale de sections/madison-inventario.liquid
    (/cart?section_id=madison-inventario). Productos sin control de inventario: 1 a 10. Si el dato no llega, 1 a 10.
  - La última opción dice "Max N" cuando es todo lo que queda en inventario (como Walmart).
  - Si aun así Shopify no tiene esas unidades (alguien compró justo antes), se avisa "Solo hay N disponibles".
  - Al cambiar, se usa /cart/change.js y el tema redibuja el carrito (evento cart:refresh); el selector se vuelve a poner solo.
  - Fotos del carrito más grandes (estilo en madison-guardados.css): se cambia la foto de 180 px por la de 360 px.
  - Diseño según la foto de Jonathan (2026-10-02): "Mi carrito (N)", "Vaciar carrito" (con confirmación),
    "Subtotal (N productos)" y "Ir a pagar".
*/
(function () {
  var SELECTORES = '.line-item .quantity-selector, .mini-cart__line-item .quantity-selector';
  var MAXIMO = 10;                 // productos sin control de inventario
  var MAXIMO_CON_INVENTARIO = 30;  // con inventario: lo que hay, hasta 30

  function refrescarCarrito() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
  }

  // Aviso abajo de la pantalla (mismo estilo que "Guardar para después"); el carrito se redibuja, así que no va dentro
  function avisar(texto) {
    var el = document.querySelector('.madison-guardados-mensaje');
    if (!el) {
      el = document.createElement('div');
      el.className = 'madison-guardados-mensaje';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = texto;
    el.classList.add('is-visible');
    clearTimeout(el._ocultar);
    el._ocultar = setTimeout(function () { el.classList.remove('is-visible'); }, 3500);
  }

  function convertir(viejo) {
    if (viejo.hasAttribute('data-madison-cantidad')) return;
    var valor = viejo.querySelector('.quantity-selector__value');
    if (!valor || !valor.dataset.line) return;
    viejo.setAttribute('data-madison-cantidad', '');

    var linea = Number(valor.dataset.line);
    var actual = parseInt(valor.dataset.currentValue || valor.value, 10) || 1;
    var mas = viejo.querySelector('[data-action="increase-quantity"]');

    var caja = document.createElement('label');
    caja.className = 'madison-cantidad';
    var texto = document.createElement('span');
    texto.className = 'madison-cantidad__texto';
    texto.textContent = 'Cant.:';
    var lista = document.createElement('select');
    lista.className = 'madison-cantidad__lista';
    lista.setAttribute('aria-label', 'Cantidad');
    lista.dataset.linea = String(linea);
    lista.dataset.actual = String(actual);
    // Mientras llega el inventario: hasta 10 (o solo la cantidad actual si el tema ya no deja sumar)
    // Lo que se ve es este texto (solo el número); la lista va invisible encima (así el recuadro no se ensancha por "Max 6")
    var valor = document.createElement('span');
    valor.className = 'madison-cantidad__valor';
    caja.appendChild(texto);
    caja.appendChild(valor);
    caja.appendChild(lista);
    poner(lista, mas && mas.disabled ? actual : Math.max(MAXIMO, actual));

    lista.addEventListener('change', function () {
      var nueva = Number(lista.value);
      mostrar(lista);
      lista.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: linea, quantity: nueva }),
        credentials: 'same-origin'
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (carrito) {
            if (!r.ok) throw carrito;
            var item = carrito.items && carrito.items[linea - 1];
            if (item && item.quantity < nueva) avisar('Solo hay ' + item.quantity + ' disponibles de este producto.');
          });
        })
        .catch(function () {
          // Shopify deja la cantidad que sí hay; se lee para decirle al cliente cuántas quedan
          return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (carrito) {
              var item = carrito.items && carrito.items[linea - 1];
              avisar(item ? 'Solo hay ' + item.quantity + ' disponibles de este producto.' : 'No hay más unidades disponibles de este producto.');
            })
            .catch(function () { avisar('No hay más unidades disponibles de este producto.'); });
        })
        .then(refrescarCarrito);
    });

    viejo.classList.add('madison-cantidad-oculto');
    viejo.parentNode.insertBefore(caja, viejo);
  }

  // En el recuadro solo el número; "Max" se ve únicamente al abrir la lista (pedido de Jonathan 2026-10-03)
  function mostrar(lista) {
    var valor = lista.parentNode && lista.parentNode.querySelector('.madison-cantidad__valor');
    if (valor) valor.textContent = lista.value;
  }

  // Opciones de 1 a "tope" (si el cliente ya tiene más, también aparece su cantidad, para no cambiarla sin querer).
  // conMax: el tope es lo que queda en inventario; el último número dice "Max 6" (como Walmart, pedido de Jonathan 2026-10-03)
  function poner(lista, tope, conMax) {
    var actual = Number(lista.dataset.actual);
    var limite = tope;
    tope = Math.max(1, tope, actual);
    var marca = conMax && tope === limite ? String(tope) : '';
    if (lista.options.length === tope && (lista.dataset.max || '') === marca) return;
    lista.dataset.max = marca;
    lista.textContent = '';
    for (var i = 1; i <= tope; i++) {
      var opcion = document.createElement('option');
      opcion.value = String(i);
      opcion.textContent = marca && i === tope ? 'Max ' + i : String(i);
      if (i === actual) opcion.selected = true;
      lista.appendChild(opcion);
    }
    mostrar(lista);
  }

  // Unidades en inventario de cada línea del carrito (sections/madison-inventario.liquid); null = sin límite
  function leerInventario() {
    return fetch('/cart?section_id=madison-inventario', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var datos = html.match(/<script type="application\/json" data-madison-inventario>([\s\S]*?)<\/script>/);
        var lista = datos ? JSON.parse(datos[1]) : [];
        return Array.isArray(lista) ? lista : [];
      })
      .catch(function () { return []; });
  }

  // Solo se ofrece lo que hay en inventario (sin control de inventario: hasta 10; nunca más de 30).
  // Si el carrito se redibuja mientras llega el dato, se vuelve a pedir (las líneas pudieron cambiar de orden).
  var pidiendo = false;
  var vuelta = 0;
  function aplicarInventario() {
    if (pidiendo) return;
    pidiendo = true;
    var esta = vuelta;
    leerInventario().then(function (inventario) {
      pidiendo = false;
      if (esta !== vuelta) return aplicarInventario();
      Array.prototype.forEach.call(document.querySelectorAll('.madison-cantidad__lista'), function (lista) {
        var hay = inventario[Number(lista.dataset.linea) - 1];
        if (typeof hay === 'number') poner(lista, Math.min(hay, MAXIMO_CON_INVENTARIO), hay <= MAXIMO_CON_INVENTARIO);
        else if (hay === null) poner(lista, MAXIMO);
      });
    });
  }

  function convertirTodos() {
    var nuevos = document.querySelectorAll(SELECTORES + ':not([data-madison-cantidad])');
    if (!nuevos.length) return;
    Array.prototype.forEach.call(nuevos, convertir);
    vuelta++;
    aplicarInventario();
  }

  // Fotos del carrito más grandes (madison-guardados.css): el tema las pide de 180 px; se usan las de 360 px para que se vean nítidas
  function fotosNitidas() {
    Array.prototype.forEach.call(document.querySelectorAll('.line-item__image-wrapper img[src*="_180x."]'), function (img) {
      img.src = img.src.replace('_180x.', '_360x.');
    });
  }

  // Diseño del carrito según la foto de Jonathan (2026-10-02): "Mi carrito (N)" con "Vaciar carrito" a la derecha,
  // "Subtotal (N productos)" y el botón "Ir a pagar". Se hace aquí y no en main-cart.liquid; se vuelve a poner
  // cuando el tema redibuja el carrito (el estilo está en madison-guardados.css).
  function textoProductos(n) {
    return n === 1 ? '(1 producto)' : '(' + n + ' productos)';
  }

  function vaciarCarrito() {
    if (!window.confirm('¿Seguro que quieres vaciar el carrito?')) return;
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .catch(function () {})
      .then(refrescarCarrito);
  }

  // "Compartir carrito" debajo de "Ir a pagar" (foto de Jonathan 2026-10-03): abre una ventana con WhatsApp, Email y
  // Copiar enlace. El enlace arma el mismo carrito a quien lo abra (/cart/ID:CANT,ID:CANT?storefront=true lleva a la página
  // del carrito, no al pago). Reemplaza el botón de la app "Cart Save and Share", que aparecía un instante junto al título.
  var ICONOS = {
    whatsapp: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path fill="#fff" d="M12 2.2A9.8 9.8 0 0 0 3.6 17l-1.4 4.8 4.9-1.3A9.8 9.8 0 1 0 12 2.2zm0 17.8a8 8 0 0 1-4.1-1.1l-.3-.2-2.9.8.8-2.8-.2-.3A8 8 0 1 1 12 20zm4.4-6c-.2-.1-1.4-.7-1.7-.8-.2-.1-.4-.1-.5.1l-.8 1c-.1.2-.3.2-.5.1a6.6 6.6 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.5-.4h-.5a.9.9 0 0 0-.7.3 2.8 2.8 0 0 0-.9 2.1 4.9 4.9 0 0 0 1 2.6 11.2 11.2 0 0 0 4.3 3.8c1.6.7 2.2.7 3 .6.5-.1 1.4-.6 1.6-1.1.2-.6.2-1 .1-1.1l-.5-.3z"/></svg>',
    email: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#1C1B1B" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 6l8.5 7 8.5-7"/></svg>',
    enlace: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#1C1B1B" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1.2 1.2"/><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.2-1.2"/></svg>'
  };
  var enlaceCompartir = '';

  function ventanaCompartir() {
    var fondo = document.querySelector('.madison-comp');
    if (fondo) return fondo;
    fondo = document.createElement('div');
    fondo.className = 'madison-comp';
    fondo.hidden = true;
    fondo.innerHTML = '<div class="madison-comp__caja" role="dialog" aria-labelledby="madison-comp-titulo">' +
      '<button type="button" class="madison-comp__cerrar" aria-label="Cerrar">&times;</button>' +
      '<div class="madison-comp__icono" aria-hidden="true"></div>' +
      '<h2 id="madison-comp-titulo" class="madison-comp__titulo">Comparte tu carrito</h2>' +
      '<p class="madison-comp__texto">Envía estos productos a alguien para que pueda verlos o completar la compra.</p>' +
      '<button type="button" class="madison-comp__opcion" data-via="whatsapp"><span class="madison-comp__logo madison-comp__logo--wa">' + ICONOS.whatsapp + '</span>Compartir por WhatsApp</button>' +
      '<button type="button" class="madison-comp__opcion" data-via="email"><span class="madison-comp__logo">' + ICONOS.email + '</span>Compartir por Email</button>' +
      '<button type="button" class="madison-comp__opcion" data-via="enlace"><span class="madison-comp__logo">' + ICONOS.enlace + '</span>Copiar enlace</button>' +
      '</div>';
    fondo.addEventListener('click', function (e) {
      if (e.target === fondo || e.target.closest('.madison-comp__cerrar')) { fondo.hidden = true; return; }
      var opcion = e.target.closest('[data-via]');
      if (!opcion || !enlaceCompartir) return;
      var via = opcion.getAttribute('data-via');
      var mensaje = 'Mira mi carrito en Madison Center: ' + enlaceCompartir;
      if (via === 'whatsapp') {
        window.open('https://wa.me/?text=' + encodeURIComponent(mensaje), '_blank');
      } else if (via === 'email') {
        location.href = 'mailto:?subject=' + encodeURIComponent('Mi carrito de Madison Center') + '&body=' + encodeURIComponent(mensaje);
      } else {
        var copiado = function () { fondo.hidden = true; avisar('Enlace del carrito copiado.'); };
        if (navigator.clipboard) {
          navigator.clipboard.writeText(enlaceCompartir).then(copiado, function () { window.prompt('Copia el enlace de tu carrito:', enlaceCompartir); });
        } else {
          window.prompt('Copia el enlace de tu carrito:', enlaceCompartir);
        }
      }
    });
    document.body.appendChild(fondo);
    return fondo;
  }

  function compartirCarrito() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        if (!carrito.items || !carrito.items.length) { avisar('Tu carrito está vacío.'); return; }
        // Enlace sin comas ni dos puntos (WhatsApp lo cortaba y llegaba 1 solo producto): /cart?compartido=ID-CANT_ID-CANT.
        // Al abrirlo, armarCompartido() pone esos productos en el carrito.
        var lineas = carrito.items.map(function (it) { return it.variant_id + '-' + it.quantity; }).join('_');
        enlaceCompartir = location.origin + '/cart?compartido=' + lineas;
        ventanaCompartir().hidden = false;
      })
      .catch(function () { avisar('No se pudo compartir el carrito. Inténtalo de nuevo.'); });
  }

  // Quien abre un carrito compartido: se vacía su carrito y se agregan los productos del enlace (como hace Shopify con sus
  // enlaces de carrito); luego se recarga /cart sin el dato en la dirección
  function armarCompartido() {
    var m = location.search.match(/[?&]compartido=([0-9_-]+)/);
    if (!m) return;
    var items = m[1].split('_').map(function (par) {
      var p = par.split('-');
      return { id: Number(p[0]), quantity: Math.max(1, parseInt(p[1], 10) || 1) };
    }).filter(function (it) { return it.id > 0; });
    if (!items.length) return;
    var enviar = function (lista) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: lista }),
        credentials: 'same-origin'
      }).then(function (r) { return r.ok; });
    };
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .then(function () { return enviar(items); })
      .then(function (ok) {
        if (ok) return;
        // Si alguno ya no está disponible, se agregan uno por uno los que sí
        return items.reduce(function (cadena, it) {
          return cadena.then(function () { return enviar([it]).catch(function () {}); });
        }, Promise.resolve());
      })
      .catch(function () {})
      .then(function () {
        var resto = location.search.replace(/([?&])compartido=[0-9_-]+&?/, '$1').replace(/[?&]$/, '');
        location.replace(location.pathname + resto);
      });
  }
  armarCompartido();

  function disenoCarrito() {
    var seccion = document.querySelector('section[data-section-type="cart"]');
    if (!seccion) return;
    // El tema redibuja el resumen (con su data-item-count al día) pero no el título: la cantidad se lee del resumen
    var resumen = seccion.querySelector('.cart-recap[data-item-count]');
    var cantidad = Number((resumen || seccion).dataset.itemCount) || 0;

    var titulo = seccion.querySelector('.page__title');
    var cuentaActual = titulo && titulo.querySelector('.madison-carrito-cuenta');
    if (cuentaActual && cuentaActual.textContent !== ' (' + cantidad + ')') cuentaActual.textContent = ' (' + cantidad + ')';
    if (titulo && !cuentaActual) {
      var cuenta = document.createElement('span');
      cuenta.className = 'madison-carrito-cuenta';
      cuenta.textContent = ' (' + cantidad + ')';
      titulo.appendChild(cuenta);
      var vaciar = document.createElement('button');
      vaciar.type = 'button';
      vaciar.className = 'madison-vaciar';
      vaciar.textContent = 'Vaciar carrito';
      vaciar.addEventListener('click', vaciarCarrito);
      titulo.insertAdjacentElement('afterend', vaciar);
    }

    var etiqueta = seccion.querySelector('.cart-recap__price-line-label');
    if (etiqueta && !etiqueta.hasAttribute('data-madison')) {
      etiqueta.setAttribute('data-madison', '');
      etiqueta.textContent = 'Subtotal ';
      var productos = document.createElement('span');
      productos.className = 'madison-subtotal-cuenta';
      productos.textContent = textoProductos(cantidad);
      etiqueta.appendChild(productos);
    }

    // Envío gratis en una sola línea: "Envío GRATIS en Caracas en pedidos a partir de $20" (si aún no llega al monto,
    // se deja el texto del tema que dice cuánto falta)
    var envio = seccion.querySelector('.page__header .page__description');
    if (envio && !envio.hasAttribute('data-madison') && /env[ií]o es gratis/i.test(envio.textContent)) {
      envio.setAttribute('data-madison', '');
      var monto = (envio.textContent.match(/\$[\d.,]+/) || ['$20'])[0];
      // Todo dentro de un <span>: el recuadro es flex y separaría cada pedazo del texto
      var frase = document.createElement('span');
      frase.appendChild(document.createTextNode('Envío '));
      var gratis = document.createElement('strong');
      gratis.textContent = 'GRATIS';
      frase.appendChild(gratis);
      frase.appendChild(document.createTextNode(' en Caracas en pedidos a partir de ' + monto));
      envio.textContent = '';
      envio.appendChild(frase);
    }

    // Si falta dinero queda el texto del tema ("¡Si agregas $8.01 podrás…"); también va en un solo <span> para que el
    // recuadro (flex) no separe las palabras
    if (envio && !envio.hasAttribute('data-madison') && envio.childNodes.length > 1) {
      envio.setAttribute('data-madison', '');
      var todo = document.createElement('span');
      while (envio.firstChild) todo.appendChild(envio.firstChild);
      envio.appendChild(todo);
    }

    // Sugeridos: "Productos recomendados para ti" debajo del título (foto de Jonathan 2026-10-03)
    var sugeridos = seccion.querySelector('[data-section-id$="-upsell"] .section__header');
    if (sugeridos && !sugeridos.querySelector('.madison-upsell-sub')) {
      var sub = document.createElement('p');
      sub.className = 'madison-upsell-sub';
      sub.textContent = 'Productos recomendados para ti';
      sugeridos.appendChild(sub);
    }

    var pagar = seccion.querySelector('.cart-recap__checkout');
    if (pagar && !pagar.hasAttribute('data-madison')) {
      pagar.setAttribute('data-madison', '');
      pagar.textContent = 'Ir a pagar';
    }
    if (pagar && !seccion.querySelector('.madison-compartir')) {
      var compartir = document.createElement('button');
      compartir.type = 'button';
      compartir.className = 'madison-compartir';
      compartir.textContent = 'Compartir carrito';
      compartir.addEventListener('click', compartirCarrito);
      pagar.insertAdjacentElement('afterend', compartir);
    }
    // "Ver mis favoritos" entre "Ir a pagar" y "Compartir carrito": borde azul, fondo blanco y corazón (pedido de Jonathan 2026-10-12)
    if (pagar && !seccion.querySelector('.madison-ver-favoritos')) {
      var verFav = document.createElement('a');
      verFav.className = 'madison-ver-favoritos';
      verFav.href = '/pages/favoritos';
      verFav.textContent = 'Ver mis favoritos';
      pagar.insertAdjacentElement('afterend', verFav);
    }
  }

  // Página del producto (celular): la lista "Cantidad:" que se abre va de 1 a lo que hay en inventario
  // (snippets/product-variant-selector.liquid; custom.js la arma al tocar el botón). El último número dice "Max 4" solo
  // DENTRO de la lista; afuera sigue solo el número (pedido de Jonathan 2026-10-03). Este aviso llega después del de custom.js.
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('#mobile-quantity-trigger')) return;
    var ultimo = document.querySelector('#quantity-options-list li:last-child');
    if (ultimo && ultimo.dataset.value && ultimo.textContent.indexOf('Max') === -1) ultimo.textContent = 'Max ' + ultimo.dataset.value;
  });

  // Tarjetas de productos (inicio, categorías, vistos, sugeridos): el botón "- 1 +" dice "Max 6" y el "+" queda gris cuando
  // en el carrito ya está todo el inventario, como Walmart (pedido de Jonathan 2026-10-03). El inventario viene en
  // data-madison-max (snippets/product-item.liquid); la cantidad se lee del carrito, y el número del botón se pone igual
  // al del carrito (custom.js cuenta desde 1 aunque el producto ya estuviera en el carrito). Estilo en madison-guardados.css.
  var TOPES = '.product-item__quantity-selector[data-madison-max]:not(.d-none)';
  var esperaTopes;

  // Tarjetas del buscador (Algolia): no traen el inventario. Se pide a sections/madison-stock.liquid con la dirección del
  // producto de la tarjeta (/products/HANDLE?section_id=madison-stock) y se pone data-madison-max (o data-madison-sinlimite).
  function consultarStock(caja) {
    if (caja.hasAttribute('data-madison-max') || caja.hasAttribute('data-madison-sinlimite')) return Promise.resolve();
    if (caja._madisonConsulta) return caja._madisonConsulta;
    var id = idDeCaja(caja);
    var p = caja, enlace = null;
    while (p && p !== document.body && !(enlace = p.querySelector('a[href*="/products/"]'))) p = p.parentElement;
    var handle = enlace && (enlace.getAttribute('href').match(/\/products\/([^/?#]+)/) || [])[1];
    if (!id || !handle) return (caja._madisonConsulta = Promise.resolve());
    caja._madisonConsulta = fetch('/products/' + handle + '?section_id=madison-stock', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var datos = html.match(/<script type="application\/json" data-madison-stock>([\s\S]*?)<\/script>/);
        var stock = datos ? JSON.parse(datos[1]) : {};
        var hay = stock[id];
        if (typeof hay === 'number') caja.setAttribute('data-madison-max', String(hay));
        else if (hay === null) caja.setAttribute('data-madison-sinlimite', '');
      })
      .catch(function () {});
    return caja._madisonConsulta;
  }

  function revisarTopes() {
    sincronizarTarjetas();
    clearTimeout(esperaTopes);
    esperaTopes = setTimeout(function () {
      var pendientes = Array.prototype.filter.call(
        document.querySelectorAll('.product-item__quantity-selector:not(.d-none):not([data-madison-max]):not([data-madison-sinlimite])'),
        function (caja) { return !caja._madisonConsulta && idDeCaja(caja); });
      if (pendientes.length) Promise.all(pendientes.map(consultarStock)).then(revisarTopes);
      fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (carrito) {
          // El numerito del carrito de arriba: custom.js lo suma y resta por su cuenta y al tocar "-" ponía "NaN"
          // (resta sin cantidad); se pone siempre el total real del carrito
          Array.prototype.forEach.call(document.querySelectorAll('.header__cart-count'), function (cuenta) {
            if (cuenta.textContent !== String(carrito.item_count)) cuenta.textContent = carrito.item_count;
          });
          var hay = {};
          (carrito.items || []).forEach(function (item) { hay[item.variant_id] = (hay[item.variant_id] || 0) + item.quantity; });
          Array.prototype.forEach.call(document.querySelectorAll(TOPES), function (caja) {
            var form = caja.closest('form');
            var id = form && form.querySelector('[name="id"]');
            var input = caja.querySelector('input');
            if (!id || !input) return;
            var cantidad = hay[id.value] || 0;
            var maximo = Number(caja.getAttribute('data-madison-max'));
            // (Ya no se cambia el número del botón: en el iPhone la cantidad subía sola. Solo se muestra "Max".)
            if (maximo > 0 && cantidad >= maximo) caja.setAttribute('data-madison-tope', 'Max ' + maximo);
            else caja.removeAttribute('data-madison-tope');
          });
          // Con 1 unidad en el carrito, el "-" se ve como papelera (como Walmart y la app, pedido de Jonathan 2026-10-04)
          Array.prototype.forEach.call(document.querySelectorAll('.product-item__quantity-selector'), function (caja) {
            var id = !caja.classList.contains('d-none') && idDeCaja(caja);
            if (id && hay[id] === 1) caja.setAttribute('data-madison-uno', '');
            else caja.removeAttribute('data-madison-uno');
          });
        })
        .catch(function () {});
    }, 150);
  }

  // custom.js cambia data-value del número al sumar o restar, y quita "d-none" al tocar "Agregar"
  new MutationObserver(function (cambios) {
    for (var i = 0; i < cambios.length; i++) {
      var el = cambios[i].target;
      if (el.classList && (el.classList.contains('product-item__quantity-selector--input') ||
          el.classList.contains('product-item__quantity-selector'))) {
        revisarTopes();
        return;
      }
    }
  }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['data-value', 'class'] });

  // Tarjetas: al tocar el número del botón "- 1 +" no se abre el teclado; se abre una lista como Walmart: "Quitar" (rojo),
  // 1, 2, 3… y "Max 6" al final (pedido de Jonathan 2026-10-03). Sin control de inventario: hasta 10. Con inventario: hasta
  // lo que hay (nunca más de 30). La cantidad actual va marcada. Se cambia con /cart/change.js.
  var cajaElegida = null;
  var abiertaEn = 0;
  function ventanaCantidad() {
    var fondo = document.querySelector('.madison-cant');
    if (fondo) return fondo;
    fondo = document.createElement('div');
    fondo.className = 'madison-cant';
    fondo.hidden = true;
    fondo.innerHTML = '<div class="madison-cant__caja" role="dialog" aria-label="Cantidad">' +
      '<div class="madison-cant__cabecera"><span>Cantidad:</span><button type="button" class="madison-cant__cerrar" aria-label="Cerrar">&times;</button></div>' +
      '<ul class="madison-cant__lista"></ul></div>';
    fondo.addEventListener('click', function (e) {
      // En el iPhone el mismo toque que abre la lista caía sobre ella y elegía un número solo: se ignoran los
      // toques del primer instante
      if (Date.now() - abiertaEn < 450) return;
      if (e.target === fondo || e.target.closest('.madison-cant__cerrar')) { fondo.hidden = true; return; }
      var opcion = e.target.closest('[data-cantidad]');
      if (opcion) { fondo.hidden = true; elegirCantidad(Number(opcion.getAttribute('data-cantidad'))); }
    });
    // Los toques en esta lista no deben llegar al buscador (Algolia): si no, cree que se tocó "afuera" y cierra los resultados
    ['mousedown', 'touchstart', 'pointerdown'].forEach(function (tipo) {
      fondo.addEventListener(tipo, function (e) { e.stopPropagation(); });
    });
    document.body.appendChild(fondo);
    return fondo;
  }

  function idDeCaja(caja) {
    var form = caja.closest('form');
    var id = form && form.querySelector('[name="id"]');
    return id ? id.value : null;
  }

  function abrirCantidad(caja) {
    var input = caja.querySelector('input');
    var actual = parseInt(input.value, 10) || 1;
    var maximo = Number(caja.getAttribute('data-madison-max')) || 0;
    var tope = maximo > 0 ? Math.min(maximo, MAXIMO_CON_INVENTARIO) : MAXIMO;
    tope = Math.max(tope, actual);
    var conMax = maximo > 0 && maximo <= MAXIMO_CON_INVENTARIO && tope === maximo;
    var fondo = ventanaCantidad();
    var lista = fondo.querySelector('.madison-cant__lista');
    lista.textContent = '';
    var quitar = document.createElement('li');
    quitar.className = 'madison-cant__quitar';
    quitar.setAttribute('data-cantidad', '0');
    quitar.textContent = 'Quitar';
    lista.appendChild(quitar);
    for (var i = 1; i <= tope; i++) {
      var li = document.createElement('li');
      li.setAttribute('data-cantidad', String(i));
      var numero = document.createElement('span');
      numero.textContent = conMax && i === tope ? 'Max ' + i : String(i);
      if (i === actual) li.className = 'is-actual';
      li.appendChild(numero);
      lista.appendChild(li);
    }
    cajaElegida = caja;
    abiertaEn = Date.now();
    fondo.hidden = false;
    // Como Walmart: la cajita sale encima del botón que se tocó (sin salirse de la pantalla)
    var cajita = fondo.querySelector('.madison-cant__caja');
    var r = caja.getBoundingClientRect();
    var alto = cajita.offsetHeight, ancho = cajita.offsetWidth;
    var arriba = r.top + r.height / 2 - alto / 2;
    var izquierda = r.left + r.width / 2 - ancho / 2;
    cajita.style.top = Math.max(12, Math.min(arriba, window.innerHeight - alto - 12)) + 'px';
    cajita.style.left = Math.max(8, Math.min(izquierda, window.innerWidth - ancho - 8)) + 'px';
    var marcada = lista.querySelector('.is-actual');
    lista.scrollTop = 0;
    if (marcada && marcada.offsetTop + marcada.offsetHeight > lista.clientHeight) lista.scrollTop = marcada.offsetTop - lista.clientHeight / 2;
  }

  function elegirCantidad(cantidad) {
    var caja = cajaElegida;
    var id = caja && idDeCaja(caja);
    if (!id) return;
    var input = caja.querySelector('input');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: cantidad }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        var item = (carrito.items || []).filter(function (it) { return String(it.variant_id) === String(id); })[0];
        if (cantidad === 0 || !item) {
          // Se quitó: vuelve el botón "Agregar"
          input.value = 1;
          input.dataset.value = 0;
          caja.classList.add('d-none');
          caja.removeAttribute('data-madison-tope');
          avisar('Se quitó del carrito.');
        } else {
          input.value = item.quantity;
          input.dataset.value = item.quantity;
          if (item.quantity < cantidad) avisar('Solo hay ' + item.quantity + ' disponibles de este producto.');
        }
        revisarTopes();
      })
      .catch(function () { avisar('No se pudo cambiar la cantidad. Inténtalo de nuevo.'); });
  }

  // La papelera (el "-" con 1 unidad) quita el producto del carrito; el tema no baja de 1, así que se hace aquí, igual que
  // "Quitar" en la lista de cantidades, y vuelve el botón "Agregar"
  document.addEventListener('click', function (e) {
    var menos = e.target.closest && e.target.closest('.product-item__quantity-selector[data-madison-uno] .product-item__quantity-selector--minus');
    if (!menos) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    cajaElegida = menos.closest('.product-item__quantity-selector');
    cajaElegida.removeAttribute('data-madison-uno');
    elegirCantidad(0);
  }, true);

  // El número del botón ya no se escribe (se elige en la lista): se bloquea el aviso "change" de custom.js (inputChange,
  // que agregaba esa cantidad otra vez).
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('product-item__quantity-selector--input')) return;
    var caja = input.closest('.product-item__quantity-selector');
    if (caja && idDeCaja(caja)) e.stopPropagation();
  }, true);

  // En el iPhone, al tocar "Agregar" el "- 1 +" aparece bajo el dedo y el iPhone ponía el cursor en el número; al quitarlo,
  // el iPhone saltaba al "Agregar" de la tarjeta siguiente (la fila se corría sola) y lo activaba: se agregaban productos
  // solos (video de Jonathan 2026-10-03). Ahora el número NUNCA recibe el cursor (no se puede tocar ni enfocar): el toque
  // cae en el botón y se abre la lista.
  function bloquearTeclado() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-item__quantity-selector--input:not([data-madison-bloqueado])'), function (input) {
      var caja = input.closest('.product-item__quantity-selector');
      if (!caja || !idDeCaja(caja)) return;
      input.setAttribute('data-madison-bloqueado', '');
      input.readOnly = true;
      input.tabIndex = -1;
      input.setAttribute('inputmode', 'none');
      input.setAttribute('aria-hidden', 'true');
    });
  }

  // Tocar el centro del botón (no el "-" ni el "+") abre la lista; se abre al soltar el dedo (click)
  document.addEventListener('click', function (e) {
    var caja = e.target.closest && e.target.closest('.product-item__quantity-selector');
    if (!caja || e.target.closest('.product-item__quantity-selector--action') || !idDeCaja(caja)) return;
    e.preventDefault();
    e.stopPropagation();
    consultarStock(caja).then(function () { abrirCantidad(caja); });
  }, true);

  // Buscador (Algolia) del celular: los resultados salen pegados debajo del buscador de la barra azul de arriba (que se queda
  // fija). La posición se guarda en --madison-aa-top (estilo en madison-guardados.css) y se actualiza al bajar la página.
  function topBuscador() {
    var formulario = document.querySelector('.aa-Form');
    if (!formulario) return;
    var abajo = Math.round(formulario.getBoundingClientRect().bottom + 6);
    if (abajo > 0) document.documentElement.style.setProperty('--madison-aa-top', abajo + 'px');
  }
  window.addEventListener('scroll', topBuscador, { passive: true });
  window.addEventListener('resize', topBuscador);
  document.addEventListener('focusin', function (e) {
    if (e.target.classList && e.target.classList.contains('aa-Input')) topBuscador();
  });

  // Buscador (Algolia): al buscar otra cosa, Algolia reutiliza las mismas tarjetas y solo les cambia el producto; el botón
  // "- 3 +" que custom.js había mostrado se quedaba en el producto nuevo (Jonathan 2026-10-03). Cada botón recuerda para qué
  // producto se abrió (data-madison-para); si la tarjeta ahora es de otro producto, vuelve a "Agregar".
  function sincronizarTarjetas() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-item__quantity-selector'), function (caja) {
      var id = idDeCaja(caja);
      if (!id) return;
      var para = caja.getAttribute('data-madison-para');
      if (para && para !== id) {
        var input = caja.querySelector('input');
        if (input) { input.value = 1; input.dataset.value = 0; }
        caja.classList.add('d-none');
        caja.removeAttribute('data-madison-tope');
        caja.removeAttribute('data-madison-para');
        if (caja.closest('form[id^="algolia-add-to-cart-"]')) {
          caja.removeAttribute('data-madison-max');
          caja.removeAttribute('data-madison-sinlimite');
          caja._madisonConsulta = null;
        }
      }
      if (!caja.classList.contains('d-none')) caja.setAttribute('data-madison-para', id);
    });
  }
  var esperaSincronizar;
  new MutationObserver(function () {
    clearTimeout(esperaSincronizar);
    esperaSincronizar = setTimeout(sincronizarTarjetas, 60);
  }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['src', 'href', 'id', 'value'] });

  // Página de búsqueda (Algolia) con la cabecera de las categorías: lo buscado como título y "N productos" (sale del
  // contador de Algolia, que queda escondido). La cabecera la arma algolia-hooks.js.
  // Mientras Algolia arma la página de resultados se veía un instante la página vieja ("Resultado de búsqueda", "Búsqueda
  // de productos"…): madison-guardados.css la esconde hasta que aparece nuestra cabecera (o 5 s, por si Algolia falla)
  if (document.body && document.body.classList.contains('template-search')) {
    setTimeout(function () { document.body.classList.add('madison-busqueda-lista'); }, 5000);
  }
  function cabeceraBusqueda() {
    var titulo = document.querySelector('.madison-busqueda__titulo');
    if (!titulo) return;
    document.body.classList.add('madison-busqueda-lista');
    var q = new URLSearchParams(location.search).get('q') || '';
    var textoTitulo = 'Resultados para \u201c' + q + '\u201d';
    if (titulo.textContent !== textoTitulo) titulo.textContent = textoTitulo;
    var cuenta = document.querySelector('.madison-busqueda__cuenta');
    var stats = document.querySelector('.ais-stats--nb-results') || document.querySelector('.ais-Stats-text');
    if (!cuenta || !stats) return;
    var m = stats.textContent.replace(/[.,](?=\d{3})/g, '').match(/(\d+)\s*resultado/i) || stats.textContent.replace(/[.,](?=\d{3})/g, '').match(/(\d+)/);
    if (!m) return;
    var n = Number(m[1]);
    var texto = n === 1 ? '1 producto' : n.toLocaleString('es-VE') + ' productos';
    if (cuenta.textContent !== texto) cuenta.textContent = texto;
  }

  // Lista del buscador: arriba, "Ver todos los resultados" lleva a la página de búsqueda (con "Ordenar por" y las vistas,
  // igual que una categoría)
  function verTodosBuscador() {
    var panel = document.querySelector('.aa-Panel .aa-PanelLayout');
    var input = document.querySelector('.aa-Input');
    if (!panel || !input || !input.value.trim()) return;
    var enlace = panel.querySelector('.madison-ver-todos');
    if (!enlace) {
      enlace = document.createElement('a');
      enlace.className = 'madison-ver-todos';
      enlace.textContent = 'Ver todos los resultados';
      panel.insertBefore(enlace, panel.firstChild);
    }
    var destino = '/search?q=' + encodeURIComponent(input.value.trim());
    if (enlace.getAttribute('href') !== destino) enlace.setAttribute('href', destino);
  }
  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('aa-Input')) setTimeout(verTodosBuscador, 400);
  });

  // Buscador propio en la barra de arriba (pedido de Jonathan 2026-10-03): NO busca mientras se escribe (aligera la página y
  // no gasta consultas de Algolia); al tocar la lupa o "buscar" del teclado va a /search?q=… (página de resultados de
  // Algolia). Reemplaza el cuadro de Algolia, que se esconde solo cuando el nuestro ya está puesto.
  var LUPA = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21"/></svg>';
  function montarBuscador() {
    var zona = document.querySelector('.header__search-bar-wrapper');
    if (!zona || zona.querySelector('.madison-buscador')) return;
    var form = document.createElement('form');
    // Sin action="/search": Algolia se mete en los formularios que van a /search. El envío lo hace este código.
    form.className = 'madison-buscador';
    form.setAttribute('role', 'search');
    var input = document.createElement('input');
    // Sin name="q": Algolia se engancha a todo input[name="q"] y volvería a buscar mientras se escribe
    input.type = 'search';
    input.className = 'madison-buscador__texto';
    input.placeholder = '\u00bfQu\u00e9 desear\u00edas buscar hoy?';
    input.setAttribute('enterkeyhint', 'search');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('spellcheck', 'false');
    input.setAttribute('aria-label', 'Buscar');
    // En la página de resultados el cuadro queda vacío (lo buscado ya sale en "Resultados para …"; pedido de Jonathan)
    var boton = document.createElement('button');
    boton.type = 'submit';
    boton.setAttribute('aria-label', 'Buscar');
    boton.innerHTML = LUPA;
    form.appendChild(input);
    form.appendChild(boton);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value.trim();
      if (!q) { input.focus(); return; }
      input.blur();
      irABuscar(q);
    });
    zona.appendChild(form);
    zona.classList.add('madison-con-buscador');
    prepararSugerencias(form, input);
  }

  // ===== Sugerencias del buscador, como Walmart y Amazon (pedido de Jonathan 2026-10-04) =====
  // Al tocar el cuadro: "búsquedas recientes" (guardadas solo en este teléfono, cada una con su "×"). Al escribir: palabras
  // sugeridas por Algolia (índice de sugerencias que arma con lo que buscan los clientes: "har" → harina, harina pan…), con la
  // foto del primer producto de cada una. Tocar una sugerencia busca; la flechita ↖ la pasa al cuadro para seguir escribiendo.
  // Solo texto y fotos pequeñas: no muestra productos mientras se escribe (eso ponía lenta la página).
  var CLAVE_RECIENTES = 'madison.busquedas';
  function leerRecientes() {
    try { var l = JSON.parse(localStorage.getItem(CLAVE_RECIENTES) || '[]'); return Array.isArray(l) ? l.filter(function (x) { return typeof x === 'string'; }) : []; }
    catch (e) { return []; }
  }
  function guardarRecientes(lista) {
    try { localStorage.setItem(CLAVE_RECIENTES, JSON.stringify(lista.slice(0, 6))); } catch (e) {}
  }
  function irABuscar(q) {
    guardarRecientes([q].concat(leerRecientes().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); })));
    location.href = '/search?q=' + encodeURIComponent(q);
  }
  function algolia(peticiones) {
    var c = window.algoliaShopify && window.algoliaShopify.config;
    if (!c || !c.app_id || !c.search_api_key) return Promise.reject(new Error('sin algolia'));
    return fetch('https://' + c.app_id + '-dsn.algolia.net/1/indexes/*/queries', {
      method: 'POST',
      headers: { 'X-Algolia-Application-Id': c.app_id, 'X-Algolia-API-Key': c.search_api_key },
      body: JSON.stringify({ requests: peticiones })
    }).then(function (r) { return r.json(); }).then(function (j) { return j.results || []; });
  }
  var FLECHA = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M17 17L7 7M7 7v8M7 7h8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var RELOJ = '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 12a8.5 8.5 0 1 0 2.5-6M3 4v4h4M12 7.5V12l3 2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var EQUIS = '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  function prepararSugerencias(form, input) {
    var panel = document.createElement('div');
    panel.className = 'madison-sug';
    panel.hidden = true;
    panel.setAttribute('role', 'listbox');
    document.body.appendChild(panel);
    var turno = 0;
    var espera = null;

    function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function cerrar() { panel.hidden = true; document.body.classList.remove('madison-sug-abierto'); }
    function abrir() {
      var r = form.getBoundingClientRect();
      panel.style.top = Math.round(r.bottom + 6) + 'px';
      panel.hidden = false;
      document.body.classList.add('madison-sug-abierto');
    }
    // Lo escrito en letra normal y lo que completa la sugerencia en negrita (como Walmart)
    function texto(sugerencia, escrito) {
      var e = escrito.trim().toLowerCase();
      if (e && sugerencia.toLowerCase().indexOf(e) === 0) return esc(sugerencia.slice(0, e.length)) + '<b>' + esc(sugerencia.slice(e.length)) + '</b>';
      return '<b>' + esc(sugerencia) + '</b>';
    }
    function fila(clase, icono, contenido, palabra, derecha) {
      return '<div class="madison-sug__fila ' + clase + '" role="option" data-q="' + esc(palabra) + '">' +
        '<span class="madison-sug__icono">' + icono + '</span><span class="madison-sug__texto">' + contenido + '</span>' + derecha + '</div>';
    }
    function mostrarRecientes() {
      var recientes = leerRecientes();
      if (!recientes.length) return cerrar();
      panel.innerHTML = recientes.map(function (q) {
        return fila('madison-sug__fila--reciente', RELOJ, esc(q), q,
          '<button type="button" class="madison-sug__accion" data-quitar="' + esc(q) + '" aria-label="Quitar ' + esc(q) + '">' + EQUIS + '</button>');
      }).join('');
      abrir();
    }
    function sugerir() {
      var q = input.value.trim();
      if (!q) return mostrarRecientes();
      var miTurno = ++turno;
      var c = window.algoliaShopify && window.algoliaShopify.config;
      // Una sola consulta: sugerencias + productos. Las sugerencias solo traen frases que los clientes ya buscaron; con dos
      // palabras nuevas ("queso gouda") no hay, así que se muestran los productos que coinciden (pedido de Jonathan)
      algolia([
        { indexName: (c && c.query_suggestions_index_name) || 'shopify_products_query_suggestions', params: 'query=' + encodeURIComponent(q) + '&hitsPerPage=8' },
        { indexName: ((c && c.index_prefix) || 'shopify_') + 'products', params: 'query=' + encodeURIComponent(q) + '&hitsPerPage=6&distinct=true&typoTolerance=min&attributesToRetrieve=title,handle,image&attributesToHighlight=&filters=' + encodeURIComponent('inventory_available:true') }
      ])
        .then(function (res) {
          var hits = ((res[0] && res[0].hits) || []).filter(function (h) { return h.query && (!h.shopify_products || h.shopify_products.exact_nb_hits !== 0); });
          var productos = ((res[1] && res[1].hits) || []).filter(function (h) { return h.handle && h.title; });
          if (miTurno !== turno) return;
          // Búsquedas recientes que coinciden van primero (con su reloj), luego las sugerencias
          var recientes = leerRecientes().filter(function (r) { return r.toLowerCase().indexOf(q.toLowerCase()) === 0; }).slice(0, 2);
          var palabras = hits.map(function (h) { return h.query; }).filter(function (p) {
            return recientes.every(function (r) { return r.toLowerCase() !== p.toLowerCase(); });
          }).slice(0, 8 - recientes.length);
          // Con pocas sugerencias se completan con productos (sin repetir los mismos nombres)
          var vistos = {};
          productos = palabras.length >= 3 ? [] : productos.filter(function (h) {
            var t = h.title.toLowerCase();
            if (vistos[t]) return false;
            vistos[t] = true;
            return true;
          }).slice(0, 6 - Math.min(palabras.length, 3));
          if (!recientes.length && !palabras.length && !productos.length) return cerrar();
          panel.innerHTML = recientes.map(function (r) {
            return fila('madison-sug__fila--reciente', RELOJ, texto(r, q), r,
              '<button type="button" class="madison-sug__accion" data-quitar="' + esc(r) + '" aria-label="Quitar ' + esc(r) + '">' + EQUIS + '</button>');
          }).join('') + palabras.map(function (p) {
            return fila('', '<span class="madison-sug__foto"></span>', texto(p, q), p,
              '<button type="button" class="madison-sug__accion" data-completar="' + esc(p) + '" aria-label="Escribir ' + esc(p) + '">' + FLECHA + '</button>');
          }).join('') + (productos.length ? '<div class="madison-sug__titulo">Productos</div>' + productos.map(function (h) {
            var img = h.image ? '<img src="' + esc(h.image + (h.image.indexOf('?') < 0 ? '?' : '&') + 'width=96') + '" alt="" loading="lazy">' : '';
            return '<a class="madison-sug__fila madison-sug__producto" href="/products/' + encodeURIComponent(h.handle) + '">' +
              '<span class="madison-sug__icono"><span class="madison-sug__foto">' + img + '</span></span>' +
              '<span class="madison-sug__texto madison-sug__texto--producto">' + esc(h.title) + '</span></a>';
          }).join('') : '');
          abrir();
          // Fotos: el primer producto disponible de cada sugerencia (una sola consulta para todas)
          if (!palabras.length || !c) return;
          algolia(palabras.map(function (p) {
            return { indexName: (c.index_prefix || 'shopify_') + 'products', params: 'query=' + encodeURIComponent(p) + '&hitsPerPage=1&attributesToRetrieve=image&attributesToHighlight=&filters=' + encodeURIComponent('inventory_available:true') };
          })).then(function (fotos) {
            if (miTurno !== turno) return;
            var cajas = panel.querySelectorAll('.madison-sug__fila:not(.madison-sug__fila--reciente) .madison-sug__foto');
            fotos.forEach(function (f, i) {
              var img = f && f.hits && f.hits[0] && f.hits[0].image;
              if (img && cajas[i]) cajas[i].innerHTML = '<img src="' + esc(img + (img.indexOf('?') < 0 ? '?' : '&') + 'width=96') + '" alt="" loading="lazy">';
            });
          }).catch(function () {});
        })
        .catch(function () { if (miTurno === turno) cerrar(); });
    }

    input.addEventListener('focus', function () { if (!input.value.trim()) mostrarRecientes(); else sugerir(); });
    input.addEventListener('input', function () {
      clearTimeout(espera);
      espera = setTimeout(sugerir, 180);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { cerrar(); input.blur(); } });
    // Tocar dentro del panel no quita el foco del cuadro (si no, el teclado se cerraba antes de elegir)
    panel.addEventListener('mousedown', function (e) { e.preventDefault(); });
    panel.addEventListener('click', function (e) {
      var quitar = e.target.closest('[data-quitar]');
      if (quitar) {
        var q = quitar.getAttribute('data-quitar');
        guardarRecientes(leerRecientes().filter(function (x) { return x !== q; }));
        return input.value.trim() ? sugerir() : mostrarRecientes();
      }
      var completar = e.target.closest('[data-completar]');
      if (completar) {
        input.value = completar.getAttribute('data-completar') + ' ';
        input.focus();
        return sugerir();
      }
      if (e.target.closest('.madison-sug__producto')) { cerrar(); return; }
      var filaElegida = e.target.closest('.madison-sug__fila');
      if (filaElegida) {
        cerrar();
        input.blur();
        irABuscar(filaElegida.getAttribute('data-q'));
      }
    });
    // Fuera del cuadro y del panel: se cierra
    document.addEventListener('click', function (e) {
      if (panel.hidden || form.contains(e.target) || panel.contains(e.target)) return;
      cerrar();
    });
    window.addEventListener('pageshow', cerrar);
  }

  // Categorías que dibuja Boost (ej. Nike Caballeros): "N% OFF" en lugar de "Oferta", igual que nuestras tarjetas
  function etiquetasBoost() {
    document.querySelectorAll('.boost-sd__product-label--sale .boost-sd__product-label-text span').forEach(function (l) {
      var tarjeta = l.closest('.boost-sd__product-item');
      var d;
      try { d = JSON.parse(tarjeta.getAttribute('data-product')); } catch (e) { return; }
      var precio = Number(d.priceMin), antes = Number(d.compareAtPriceMin);
      if (!(antes > precio)) return;
      var texto = Math.round((antes - precio) / antes * 100) + '% OFF';
      if (l.textContent !== texto) l.textContent = texto;
    });
    document.querySelectorAll('.boost-sd__product-item .boost-sd__button-text').forEach(function (t) {
      if (/^\s*Escoger/i.test(t.textContent)) t.textContent = 'Opciones';
    });
    // "Entrega en 90 min" debajo del precio (igual que snippets/madison-entrega-90.liquid), salvo en los agotados
    document.querySelectorAll('.boost-sd__product-item .boost-sd__product-price').forEach(function (precio) {
      var tarjeta = precio.closest('.boost-sd__product-item');
      if (tarjeta.querySelector('.madison-entrega') || tarjeta.querySelector('.boost-sd__product-label--soldout, .boost-sd__product-label--sold-out')) return;
      precio.insertAdjacentHTML('afterend', '<div class="madison-entrega"><svg width="7" height="9" viewBox="0 0 11 13" aria-hidden="true" focusable="false">' +
        '<path d="M6.6 0 0.8 7.3h3.9L3.9 13l6.3-7.6H6.2L6.6 0z" fill="#FDC441"/></svg><span>Entrega en <strong>90 min</strong></span></div>');
    });
    // Precio y precio tachado en la misma línea: se achican hasta caber, como en nuestras tarjetas
    document.querySelectorAll('.boost-sd__product-item .boost-sd__product-price-content').forEach(function (linea) {
      if (!linea.clientWidth || (linea.getAttribute('data-madison-ancho') === String(linea.clientWidth) && linea.scrollWidth <= linea.clientWidth + 1)) return;
      var precio = linea.querySelector('.boost-sd__product-price--sale') || linea.querySelector(':scope > .boost-sd__format-currency:not(.boost-sd__product-price--compare)');
      var tachado = linea.querySelector('.boost-sd__product-price--compare');
      if (!precio) return;
      var grande = 18;
      do {
        precio.style.setProperty('font-size', grande + 'px', 'important');
        precio.querySelectorAll('.boost-sd__format-currency').forEach(function (x) { x.style.setProperty('font-size', grande + 'px', 'important'); });
        if (tachado) [tachado].concat([].slice.call(tachado.querySelectorAll('.boost-sd__format-currency'))).forEach(function (x) {
          x.style.setProperty('font-size', Math.max(5, grande * 0.46).toFixed(1) + 'px', 'important');
        });
        grande -= 0.5;
      } while (linea.scrollWidth > linea.clientWidth && grande >= 9);
      linea.setAttribute('data-madison-ancho', String(linea.clientWidth));
    });
  }

  // Carrito en el celular: el aviso de envío gratis y la fila "Cant. / Quitar" siempre en UNA línea, en cualquier teléfono
  // (en un iPhone grande con letra más grande "Quitar" bajaba y el aviso ocupaba dos líneas). Se achica la letra lo justo.
  function unaLineaCarrito() {
    if (window.innerWidth > 640) return;
    var aviso = document.querySelector('section[data-section-type="cart"] .page__header .page__description');
    if (aviso && aviso.clientWidth && aviso.getAttribute('data-madison-ancho') !== aviso.clientWidth + '|' + aviso.textContent.length) {
      var letra = 13;
      do {
        aviso.style.setProperty('font-size', letra + 'px', 'important');
        letra -= 0.5;
      } while (aviso.scrollWidth > aviso.clientWidth && letra >= 8.5);
      aviso.setAttribute('data-madison-ancho', aviso.clientWidth + '|' + aviso.textContent.length);
    }
    document.querySelectorAll('.line-item__quantity.hidden-tablet-and-up').forEach(function (fila) {
      var cant = fila.querySelector('.madison-cantidad'), quitar = fila.querySelector('.line-item__quantity-remove');
      if (!cant || !quitar || !fila.clientWidth || fila.getAttribute('data-madison-ancho') === String(fila.clientWidth)) return;
      var pasos = [['10px', '13px'], ['6px', '13px'], ['4px', '12px'], ['3px', '11px']];
      for (var i = 0; i < pasos.length; i++) {
        fila.style.setProperty('column-gap', pasos[i][0], 'important');
        quitar.style.setProperty('font-size', pasos[i][1], 'important');
        if (Math.abs(quitar.getBoundingClientRect().top - cant.getBoundingClientRect().top) < 20) break;
      }
      fila.setAttribute('data-madison-ancho', String(fila.clientWidth));
    });
  }
  window.addEventListener('resize', function () { setTimeout(unaLineaCarrito, 100); });

  // Ficha del producto: "Ahorras $29" al lado del precio tachado; el sello BCV va aparte a la derecha (foto de Jonathan 2026-10-04).
  // Se recalcula solo al cambiar de talla o color (el tema vuelve a dibujar el precio y esto se vuelve a poner).
  function ahorroFicha() {
    document.querySelectorAll('.product-form__info-item .price-list').forEach(function (lista) {
      var ahora = lista.querySelector('.price--highlight') || lista.querySelector('.price:not(.price--compare)');
      var antes = lista.querySelector('.price--compare');
      var aviso = lista.querySelector('.madison-ahorro');
      var numero = function (el) { return el ? Number(el.textContent.replace(/[^0-9.,]/g, '').replace(/,(?=\d{3}\b)/g, '').replace(',', '.')) : 0; };
      var diferencia = Math.round((numero(antes) - numero(ahora)) * 100) / 100;
      if (!antes || !(diferencia > 0) || antes.offsetParent === null) { if (aviso) aviso.remove(); return; }
      var texto = 'Ahorras $' + (diferencia % 1 ? diferencia.toFixed(2) : String(diferencia));
      if (!aviso) {
        aviso = document.createElement('span');
        aviso.className = 'madison-ahorro';
        antes.insertAdjacentElement('afterend', aviso);
      }
      if (aviso.textContent !== texto) aviso.textContent = texto;
    });
  }

  // Página del Loyalty Club (/pages/rewards): se carga el diseño nuevo (madison-loyalty.js), solo en esa página
  if (/^\/pages\/rewards\/?$/.test(location.pathname)) {
    var propio = document.querySelector('script[src*="madison-carrito.js"]');
    if (propio) {
      var lealtad = document.createElement('script');
      // Con un ?v= que cambia cada minuto: si no, al cambiar madison-loyalty.js se seguía viendo la versión vieja guardada
      lealtad.src = propio.src.replace(/madison-carrito\.js(\?[^#]*)?/, 'madison-loyalty.js?v=' + Math.floor(Date.now() / 60000));
      lealtad.defer = true;
      // Si no carga (o tarda más de 15 s), se muestra la página de siempre para no dejar al cliente esperando
      var dejarOriginal = function () { if (!document.documentElement.classList.contains('mll-lista')) document.documentElement.classList.add('mll-fallo'); };
      lealtad.onerror = dejarOriginal;
      setTimeout(dejarOriginal, 15000);
      document.head.appendChild(lealtad);
    } else {
      document.documentElement.classList.add('mll-fallo');
    }
  }

  // Carrito vacío como Amazon (foto de Jonathan 2026-10-04): dibujo de carrito con canasta amarilla, "Tu carrito de Madison está
  // vacío" y, solo si no inició sesión, botones para iniciar sesión y crear cuenta (sin franjas grises ni "Seguir comprando", pedido de Jonathan)
  var DIBUJO_CARRITO_VACIO = '<svg viewBox="0 0 320 210" aria-hidden="true">' +
    '<path d="M248 20c-8 0-12 4-14 9-7 0-12 4-12 9h40c0-6-5-10-10-11-1-4-2-7-4-7z" fill="#E4E6EF"/>' +
    '<path d="M64 38c-6 0-9 3-11 7-5 0-9 3-9 7h31c0-4-4-7-8-8-1-3-2-6-3-6z" fill="#E4E6EF"/>' +
    '<path d="M110 60c10-34 70-44 104-24 30 18 26 62 8 90-20 32-76 46-108 22-26-20-14-58-4-88z" fill="#E6F0FB"/>' +
    '<g fill="none" stroke="#9AA3B5" stroke-width="2" stroke-linecap="round"><path d="M72 150c-9 0-14-8-11-15-6-4-4-14 4-15 1-8 13-9 16-2 8-1 12 8 7 14 4 9-4 18-16 18zM73 132v40M73 145l-6-6M73 152l6-5"/>' +
    '<path d="M250 140c-11 0-17-10-13-18-7-5-5-17 5-18 2-10 16-11 19-2 10-1 15 9 9 17 5 11-5 21-20 21zM250 118v54M250 134l-7-7M250 144l8-7"/></g>' +
    '<path d="M40 172h240" stroke="#7E8AA6" stroke-width="2.5" stroke-linecap="round"/>' +
    '<g stroke="#C3CAD8" stroke-width="2" stroke-linecap="round"><path d="M56 180h8M232 180h10M86 184h6M210 184h8"/></g>' +
    '<path d="M96 44h18l20 102h86" fill="none" stroke="#6B7690" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M94 44h14" stroke="#E57373" stroke-width="7" stroke-linecap="round"/>' +
    '<path d="M118 62h118l-14 62H130z" fill="#FDC441" stroke="#6B7690" stroke-width="4" stroke-linejoin="round"/>' +
    '<g stroke="#fff" stroke-width="3"><path d="M138 64l4 58M160 64l2 58M182 64v58M204 64l-2 58M224 64l-4 58M122 84h112M126 104h104"/></g>' +
    '<path d="M118 62h118l-14 62H130z" fill="none" stroke="#6B7690" stroke-width="4" stroke-linejoin="round"/>' +
    '<circle cx="146" cy="160" r="10" fill="#fff" stroke="#6B7690" stroke-width="4"/><circle cx="146" cy="160" r="3.5" fill="#6B7690"/>' +
    '<circle cx="204" cy="160" r="10" fill="#fff" stroke="#6B7690" stroke-width="4"/><circle cx="204" cy="160" r="3.5" fill="#6B7690"/>' +
    '<g stroke="#6B7690" stroke-width="3" stroke-linecap="round"><path d="M200 30l2 10M212 28l-4 11M220 38l-9 6"/></g></svg>';
  function carritoVacio() {
    var vacio = document.querySelector('section[data-section-type="cart"] .empty-state');
    if (!vacio || vacio.hasAttribute('data-madison')) return;
    vacio.setAttribute('data-madison', '');
    var cuenta = document.querySelector('.header__account-icon');
    var conSesion = cuenta && /\/account\/?$/.test(cuenta.getAttribute('href') || '');
    vacio.innerHTML = '<div class="madison-vacio">' +
      '<div class="madison-vacio__dibujo">' + DIBUJO_CARRITO_VACIO + '</div>' +
      '<h1 class="madison-vacio__titulo">Tu carrito de Madison<br>está vacío</h1>' +
      // "Descubre nuestros productos!" → inicio, justo debajo del título (pedido de Jonathan 2026-10-07)
      '<a class="madison-vacio__ofertas madison-vacio__descubre" href="/">Descubre Nuestros Productos!</a>' +
      (conSesion ? '' :
        '<a class="madison-vacio__boton madison-vacio__boton--amarillo" href="/account/login?return_url=/cart">Inicia sesión en tu cuenta</a>' +
        '<a class="madison-vacio__boton madison-vacio__boton--borde" href="/account/register">Crea tu cuenta</a>') + '</div>';
  }

  function revisar() {
    etiquetasBoost();
    carritoVacio();
    ahorroFicha();
    unaLineaCarrito();
    montarBuscador();
    verTodosBuscador();
    cabeceraBusqueda();
    topBuscador();
    sincronizarTarjetas();
    bloquearTeclado();
    convertirTodos();
    fotosNitidas();
    disenoCarrito();
  }

  new MutationObserver(function (cambios) {
    for (var i = 0; i < cambios.length; i++) {
      if (cambios[i].addedNodes.length) { revisar(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // "Mantenerme conectado" (página de inicio de sesión, main-customers-login.liquid): si el cliente lo DESMARCA, se guarda
  // un aviso en el teléfono y una cookie que dura solo mientras el navegador está abierto. Si después vuelve con sesión
  // abierta y esa cookie ya no está (cerró el navegador), se cierra su sesión. Marcado = como siempre (sesión abierta).
  function sesionTemporal() {
    var aviso = null;
    try { aviso = localStorage.getItem('madison.salirAlCerrar'); } catch (e) {}
    if (!aviso) return;
    var cuenta = document.querySelector('.header__account-icon');
    var conSesion = cuenta && /\/account\/?$/.test(cuenta.getAttribute('href') || '');
    if (!conSesion) return;
    if (/(?:^|;\s*)madison_sesion=1/.test(document.cookie)) return;
    try { localStorage.removeItem('madison.salirAlCerrar'); } catch (e) {}
    location.href = '/account/logout';
  }

  // Carrito guardado en la cuenta del cliente (pedido de Jonathan 2026-10-05): con sesión iniciada, el servidor
  // guardados-madison (/apps/guardados/carrito, firmado por Shopify) recuerda CUÁL es su carrito de Shopify (solo el número;
  // productos y precios viven en Shopify). Al entrar desde otro teléfono o computadora se usa ese mismo carrito, y lo que
  // hubiera en el carrito de este navegador se suma (no se pierde nada). Es el mismo carrito que ve la app.
  var CARRITO_API = '/apps/guardados/carrito';
  var CARRITO_GID = 'gid://shopify/Cart/';
  function leerCookieCarrito() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function ponerCookieCarrito(token) {
    document.cookie = 'cart=' + encodeURIComponent(token) + '; path=/; max-age=' + (14 * 24 * 3600) + '; SameSite=Lax';
  }
  function servidorCarrito(token) {
    return fetch(CARRITO_API, {
      method: token ? 'POST' : 'GET',
      headers: token ? { 'Content-Type': 'application/json' } : {},
      body: token ? JSON.stringify({ carrito: CARRITO_GID + token }) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok || (r.headers.get('Content-Type') || '').indexOf('json') < 0) throw new Error('servidor');
      return r.json();
    }).then(function (j) { return j.carrito ? String(j.carrito).replace(CARRITO_GID, '') : ''; });
  }
  function leerCarrito() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function avisarCarritoCambio(carrito) {
    document.querySelectorAll('.header__cart-count').forEach(function (c) { c.textContent = carrito.item_count; });
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (/^\/cart\/?$/.test(location.pathname)) location.reload();
  }
  function carritoEnCuenta() {
    var cuenta = document.querySelector('.header__account-icon');
    if (!cuenta || !/\/account\/?$/.test(cuenta.getAttribute('href') || '')) return;
    var actual = leerCookieCarrito();
    var listo = null;
    try { listo = sessionStorage.getItem('madison.carritoCuenta'); } catch (e) {}
    if (listo !== null && listo === actual) return; // ya se revisó en esta visita con este mismo carrito
    var marcar = function (token) { try { sessionStorage.setItem('madison.carritoCuenta', token || ''); } catch (e) {} };
    servidorCarrito().then(function (guardado) {
      return leerCarrito().then(function (local) {
        // 1) La cuenta no tiene carrito todavía: se guarda el de este navegador (si tiene algo)
        if (!guardado) {
          if (local.item_count > 0) return servidorCarrito(local.token).then(function () { marcar(local.token); });
          marcar(actual);
          return;
        }
        // 2) Es el mismo carrito: nada que hacer
        if (guardado === local.token) { marcar(local.token); return; }
        // 3) Otro carrito: se pasa a usar el de la cuenta y se le suma lo de este navegador
        ponerCookieCarrito(guardado);
        return leerCarrito().then(function (deCuenta) {
          if (deCuenta.token !== guardado) {
            // El carrito de la cuenta ya no existe (por ejemplo, se pagó): se vuelve al de este navegador
            ponerCookieCarrito(local.token);
            return servidorCarrito(local.token).then(function () { marcar(local.token); });
          }
          var items = (local.items || []).map(function (i) { return { id: i.variant_id, quantity: i.quantity }; });
          var sumar = items.length
            ? fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }).catch(function () {})
            : Promise.resolve();
          return sumar.then(leerCarrito).then(function (final) {
            marcar(final.token);
            avisarCarritoCambio(final);
          });
        });
      });
    }).catch(function () {}); // si el servidor no responde, se sigue con el carrito de este navegador
  }

  function iniciar() {
    sesionTemporal();
    carritoEnCuenta();
    revisar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

// Madison: Favoritos en toda la web (corazón en las tarjetas de producto, 2026-10-07). madison-favoritos.js antes solo se
// cargaba en la ficha; aquí se carga en todas las páginas si no está ya.
(function () {
  if (window.MadisonFavoritos || document.querySelector('script[src*="madison-favoritos.js"]')) return;
  var yo = document.querySelector('script[src*="madison-carrito.js"]');
  if (!yo) return;
  var s = document.createElement('script');
  s.src = yo.src.replace(/madison-carrito\.js.*$/, 'madison-favoritos.js?v=fa7be3fe'); // cambiar la versión cada vez que se sube madison-favoritos.js
  s.defer = true;
  document.head.appendChild(s);
})();

// Madison 2026-10-07: los botones de vista de las categorías con los mismos íconos del buscador (cuadrícula primero, luego lista).
// Solo se cambia el dibujo y el orden; el tema sigue haciendo el cambio de vista al tocarlos. El estilo está en madison-guardados.css.
(function () {
  var ICONOS = {
    grid: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><rect x="3" y="3" width="8" height="8" rx="2"/><rect x="13" y="3" width="8" height="8" rx="2"/><rect x="3" y="13" width="8" height="8" rx="2"/><rect x="13" y="13" width="8" height="8" rx="2"/></svg>',
    list: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><circle cx="4.5" cy="6" r="1.6"/><circle cx="4.5" cy="12" r="1.6"/><circle cx="4.5" cy="18" r="1.6"/><rect x="8.5" y="5" width="12.5" height="2" rx="1"/><rect x="8.5" y="11" width="12.5" height="2" rx="1"/><rect x="8.5" y="17" width="12.5" height="2" rx="1"/></svg>'
  };
  function modernizar() {
    Array.prototype.forEach.call(document.querySelectorAll('.collection__layout-button[data-layout-mode]'), function (b) {
      var modo = b.getAttribute('data-layout-mode');
      if (b.getAttribute('data-madison') === modo || !ICONOS[modo]) return;
      b.innerHTML = ICONOS[modo];
      b.setAttribute('data-madison', modo);
      if (modo === 'grid') {
        var primero = b.parentNode.querySelector('.collection__layout-button');
        if (primero && primero !== b) b.parentNode.insertBefore(b, primero);
      }
    });
  }
  var espera;
  function iniciar() {
    modernizar();
    new MutationObserver(function () { clearTimeout(espera); espera = setTimeout(modernizar, 30); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

// Madison 2026-10-07: opciones de "Ordenar por" del buscador con los mismos nombres y orden que en las categorías.
// Cada opción es un índice de Algolia; solo aparecen las que estén ACTIVADAS en la app de Algolia (Sort orders).
// "Popular" y las demás que no estén en la lista se quitan.
(function () {
  var OPCIONES = [
    ['shopify_products', 'Destacados'],
    ['shopify_products_title_asc', 'Alfabético: A – Z'],
    ['shopify_products_title_desc', 'Alfabético: Z – A'],
    ['shopify_products_price_asc', 'Precio: menor a mayor'],
    ['shopify_products_price_desc', 'Precio: mayor a menor']
  ];
  function arreglar() {
    var sel = document.querySelector('.madison-busqueda__orden select');
    if (!sel) return;
    // 2026-10-09: los 4 índices de orden YA existen en Algolia (verificado), pero la configuración que el app de Algolia
    // le pasa a la página sigue con solo "Popular". Se agregan aquí las opciones que falten.
    OPCIONES.forEach(function (x) {
      if (!sel.querySelector('option[value="' + x[0] + '"]')) {
        var o = document.createElement('option');
        o.value = x[0];
        o.textContent = x[1];
        o.className = 'ais-SortBy-option';
        sel.appendChild(o);
      }
    });
    var valor = sel.value;
    var orden = [];
    Array.prototype.forEach.call(sel.options, function (o) {
      var pos = -1;
      OPCIONES.forEach(function (x, i) { if (x[0] === o.value) pos = i; });
      if (pos < 0) { if (o.value !== valor) o.remove(); return; }
      if (o.textContent !== OPCIONES[pos][1]) o.textContent = OPCIONES[pos][1];
      orden.push([pos, o]);
    });
    orden.sort(function (a, b) { return a[0] - b[0]; });
    var enOrden = orden.every(function (x, i) { return sel.options[i] === x[1]; });
    if (!enOrden) { orden.forEach(function (x) { sel.appendChild(x[1]); }); sel.value = valor; }
  }
  var espera;
  function iniciar() {
    if (!/\/search/.test(location.pathname)) return;
    arreglar();
    new MutationObserver(function () { clearTimeout(espera); espera = setTimeout(arreglar, 30); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

// Madison 2026-10-07: "Filtrar por talla" en el buscador (Algolia), igual al de Ropa y Calzado (Search & Discovery).
// - Aparece solo si en lo buscado hay productos "Ropa Y Calzados" (o si ya hay tallas elegidas).
// - Las tallas y cantidades salen de Algolia (options.talla), contando solo lo que hay en inventario.
// - Varias tallas = productos con CUALQUIERA de ellas. El buscador de Algolia rehace su "filters" en cada búsqueda, por eso
//   las tallas se agregan a la consulta justo cuando sale hacia Algolia (cliente del buscador). No recarga la página.
(function () {
  // Estuvo APAGADO (2026-10-07); Jonathan pidió encenderlo el 2026-10-08 "a ver cómo funciona", con el mismo diseño de las
  // categorías de Ropa y Calzado (ventana angosta a la izquierda, debajo del botón). Para apagarlo: ENCENDIDO = false.
  var ENCENDIDO = true;
  if (!ENCENDIDO) return;
  if (!/\/search/.test(location.pathname)) return;
  var TIPO = 'Ropa Y Calzados';
  var BASE = 'inventory_quantity > 0';
  // 2026-10-09 (Jonathan): "zapatos", "calzado", "tenis", "ropa"… = TODA esa categoría (no lo que diga la palabra: traía
  // medias, trajes de baño… y "calzado" casi nada porque los nombres dicen "zapatos"), con Filtrar por Marca → Para → tallas
  var CAT_FIJA = { zapatos: 'todo-el-calzado', zapato: 'todo-el-calzado', calzado: 'todo-el-calzado', calzados: 'todo-el-calzado', tenis: 'todo-el-calzado', ropa: 'toda-la-ropa' };
  function palabraSola(q) { return String(q || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim(); }
  function catDe(q) { return CAT_FIJA[palabraSola(q)] || ''; }
  var CAT = '';
  // 2026-10-21 (Jonathan): "perfumes", "relojes", "carteras"… = TODA esa categoría por tipo de producto, con Filtrar por marca
  var TIPO_FIJO = { perfume: ['Perfumes'], perfumes: ['Perfumes'], reloj: ['Relojes', 'Smart Watches'], relojes: ['Relojes', 'Smart Watches'],
    cartera: ['Carteras Bolsos y Maletas'], carteras: ['Carteras Bolsos y Maletas'], bolso: ['Carteras Bolsos y Maletas'],
    bolsos: ['Carteras Bolsos y Maletas'], maleta: ['Carteras Bolsos y Maletas'], maletas: ['Carteras Bolsos y Maletas'] };
  function tfDe(q) { return TIPO_FIJO[palabraSola(q)] || null; }
  var TF = null;
  try { CAT = catDe(new URLSearchParams(location.search).get('q')); TF = tfDe(new URLSearchParams(location.search).get('q')); } catch (e) {}
  function tiposTF() { return '(' + TF.map(function (t) { return 'product_type:' + comillas(t); }).join(' OR ') + ')'; }
  function consultaReal(q) { return (CAT && catDe(q) === CAT) || (TF && tfDe(q)) ? '' : (q || ''); }
  function base() { return BASE + (CAT ? ' AND collections:' + comillas(CAT) : '') + (TF ? ' AND ' + tiposTF() : ''); }
  // En el filtro por marca no se limita a lo que dice la palabra en el nombre (muchos perfumes no dicen "perfume")
  function limite(p) { if (!soloMarca) { p.restrictSearchableAttributes = SOLO_EN; p.typoTolerance = 'min'; } return p; }
  var elegidas = [];   // tallas aplicadas en el buscador
  var marcadas = [];   // tallas marcadas en la ventana (antes de "Ver resultados")
  // 2026-10-09 (Jonathan): "nike" traía tallas de ropa y de zapatos, de adulto y de niño, todo junto. Arriba de las tallas
  // se elige Para (Damas / Caballeros / Niños) y Tipo (Ropa / Zapatos), con las etiquetas de los productos; las tallas
  // de abajo cambian según lo elegido. Uno de cada grupo (tocar otra vez lo quita).
  // 2026-10-09: "zapatos" traía medias, trajes de baño y boxers (Algolia toma zapatos = calzados y todo es "Ropa Y Calzados").
  // En el filtro (y en los resultados cuando hay algo filtrado) solo cuenta lo que dice la palabra en nombre, etiquetas o marca.
  var SOLO_EN = ['title', 'tags', 'vendor'];
  var GRUPOS = [['Para', ['Damas', 'Caballeros', 'Niños']], ['Tipo', ['Ropa', 'Zapatos']]];
  // 2026-10-09 (Jonathan): si lo buscado tiene varias marcas (ej. "zapatos"), arriba de todo sale Marca (opcional)
  // 2026-10-21 (Jonathan): perfumes también por Presentación: "Decant" (etiqueta Decant) o "Frasco completo" (sin ella)
  var CLAVES = ['Marca', 'Para', 'Tipo', 'Presentación'];
  var VACIO = { Marca: '', Para: '', Tipo: '', 'Presentación': '' };
  function copia(g) { return { Marca: (g && g.Marca) || '', Para: (g && g.Para) || '', Tipo: (g && g.Tipo) || '', 'Presentación': (g && g['Presentación']) || '' }; }
  function claveG(g) { return CLAVES.map(function (k) { return g[k]; }).join('#'); }
  var verTodasMarcas = false;
  var grupo = copia(VACIO);      // aplicado
  var grupoMarca = copia(VACIO); // en la ventana
  var fondo, lista, ver, espera, ultimaConsulta = null, hayRopa = false;
  // 2026-10-21 (Jonathan): relojes, carteras/bolsos/maletas y perfumes → "Filtrar por marca" (solo Marca, sin tallas)
  var TIPOS_MARCA = ['Relojes', 'Smart Watches', 'Carteras Bolsos y Maletas', 'Perfumes'];
  var soloMarca = false, esPerfume = false;
  function filtroTipos() {
    return soloMarca ? '(' + TIPOS_MARCA.map(function (t) { return 'product_type:' + comillas(t); }).join(' OR ') + ')' : 'product_type:' + comillas(TIPO);
  }

  function helper() { try { return algoliaShopify.instantsearch.search.helper; } catch (e) { return null; } }
  function comillas(v) { return '"' + String(v).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"'; }
  function bonita(v) {
    return String(v).toLowerCase().replace(/(^|[\s\-.&])([a-záéíóúñ])/g, function (m, a, b) { return a + b.toUpperCase(); });
  }
  function deGrupo(g) {
    return CLAVES.filter(function (k) { return g && g[k]; }).map(function (k) {
      if (k === 'Presentación') return g[k] === 'Decant' ? 'tags:"Decant"' : 'NOT tags:"Decant"';
      return (k === 'Marca' ? 'vendor:' : 'tags:') + comillas(g[k]);
    });
  }
  function filtro(tallas, g) {
    var partes = [base()].concat(deGrupo(g));
    if (tallas.length) partes.push('(' + tallas.map(function (v) { return 'options.talla:' + comillas(v); }).join(' OR ') + ')');
    return partes.join(' AND ');
  }
  // Consulta aparte a Algolia (sin agrupar variantes) para saber las tallas y cuántos productos hay
  function consultar(tallas, conFacetas, g) {
    var h = helper();
    var p = limite({ query: consultaReal(h.state.query), filters: filtro(tallas, g), hitsPerPage: 0, distinct: true });
    if (conFacetas) { p.facets = ['options.talla', 'product_type', 'tags']; p.distinct = false; p.maxValuesPerFacet = 200; }
    return algoliaShopify.searchClient.search([{ indexName: 'shopify_products', params: p }])
      .then(function (r) { return r.results[0]; });
  }
  var ORDEN = ['XXS', '2XS', 'XS', 'X-SMALL', 'S', 'SMALL', 'M', 'MEDIUM', 'L', 'LARGE', 'XL', 'X-LARGE', 'XXL', '2XL', '2X-LARGE', 'XX-LARGE', '3XL', '3X-LARGE', 'XXX-LARGE'];
  function rango(v) {
    var n = parseFloat(String(v).replace(',', '.'));
    if (!isNaN(n) && /^\s*\d/.test(v)) return [0, n];
    var k = ORDEN.indexOf(String(v).split(/\s*[=(]/)[0].trim().toUpperCase());
    return k >= 0 ? [1, k] : [2, 0];
  }
  function ordenar(a, b) {
    var x = rango(a), y = rango(b);
    return x[0] - y[0] || x[1] - y[1] || String(a).localeCompare(String(b), 'es');
  }

  function ventana() {
    if (fondo) return;
    fondo = document.createElement('div');
    fondo.className = 'madison-talla__fondo';
    fondo.hidden = true;
    fondo.innerHTML = '<div class="madison-talla__hoja" role="dialog" aria-label="Filtrar por talla">' +
      '<div class="madison-talla__cab"><b>Filtrar por talla</b><button type="button" class="madison-talla__cerrar" aria-label="Cerrar">&times;</button></div>' +
      '<div class="madison-talla__lista"></div>' +
      '<div class="madison-talla__pie"><button type="button" class="madison-talla__borrar">Limpiar</button><button type="button" class="madison-talla__ver">Ver resultados</button></div>' +
      '</div>';
    lista = fondo.querySelector('.madison-talla__lista');
    ver = fondo.querySelector('.madison-talla__ver');
    fondo.addEventListener('click', function (e) {
      if (Date.now() - abiertaEn < 450) return; // el mismo toque que abre no debe cerrarla (iPhone)
      if (e.target === fondo || e.target.closest('.madison-talla__cerrar')) return cerrar();
      if (e.target.closest('.madison-talla__mas')) { verTodasMarcas = true; pintar(); return; }
      var gb = e.target.closest('.madison-talla__g');
      if (gb) {
        var k = gb.getAttribute('data-grupo'), val = gb.getAttribute('data-valor');
        grupoMarca[k] = grupoMarca[k] === val ? '' : val;
        pintar();
        return;
      }
      var op = e.target.closest('.madison-talla__op');
      if (op) {
        var v = op.getAttribute('data-valor');
        var i = marcadas.indexOf(v);
        if (i >= 0) marcadas.splice(i, 1); else marcadas.push(v);
        op.classList.toggle('on', i < 0);
        contar();
      }
      if (e.target.closest('.madison-talla__borrar')) {
        marcadas = [];
        grupoMarca = copia(VACIO);
        pintar();
      }
      if (e.target.closest('.madison-talla__ver')) { aplicar(marcadas.slice(), copia(grupoMarca)); cerrar(); }
    });
    document.body.appendChild(fondo);
  }
  function contar() {
    clearTimeout(espera);
    ver.textContent = 'Ver resultados';
    espera = setTimeout(function () {
      var pedidas = marcadas.slice();
      var clave = pedidas.join('|') + '#' + claveG(grupoMarca);
      consultar(pedidas, false, grupoMarca).then(function (r) {
        if (clave !== marcadas.join('|') + '#' + claveG(grupoMarca)) return;
        ver.textContent = 'Ver ' + r.nbHits + (r.nbHits === 1 ? ' resultado' : ' resultados');
      }).catch(function () {});
    }, 250);
  }
  var abiertaEn = 0;
  function abrir(e) {
    ventana();
    marcadas = elegidas.slice();
    lista.innerHTML = '<p class="madison-talla__vacio">Cargando tallas…</p>';
    fondo.hidden = false;
    abiertaEn = Date.now();
    document.body.classList.add('madison-talla-abierta');
    // Como en las categorías: debajo del botón, a la izquierda, sin pasar de lo visible de la pantalla
    var boton = e && e.currentTarget;
    var tope = boton ? Math.max(8, boton.getBoundingClientRect().bottom + 8) : 80;
    var visible = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var barraPrueba = document.getElementById('PBarNextFrameWrapper');
    if (barraPrueba && barraPrueba.getBoundingClientRect().height) visible -= barraPrueba.getBoundingClientRect().height;
    tope = Math.max(8, Math.min(tope, visible - 280));
    fondo.style.setProperty('--madison-talla-top', tope + 'px');
    fondo.querySelector('.madison-talla__hoja').style.maxHeight = (visible - tope - 12) + 'px';
    grupoMarca = copia(grupo);
    verTodasMarcas = false;
    pintar();
  }
  // Dibuja los grupos (Para / Tipo) y las tallas que corresponden a lo elegido en la ventana
  var pintando = 0;
  function pintar() {
    var n = ++pintando;
    var h0 = helper();
    var pMarcas = algoliaShopify.searchClient.search([{ indexName: 'shopify_products', params: limite({
      query: consultaReal(h0 && h0.state.query), filters: [base(), filtroTipos()].concat(deGrupo({ 'Presentación': grupoMarca['Presentación'] })).join(' AND '), hitsPerPage: 0,
      facets: ['vendor'], maxValuesPerFacet: soloMarca ? 300 : 60 }) }]).then(function (r) { return r.results[0]; });
    Promise.all([consultar([], true, { Marca: grupoMarca.Marca }), consultar([], true, grupoMarca), pMarcas]).then(function (rs) {
      if (n !== pintando) return;
      var etiquetas = (rs[0].facets && rs[0].facets.tags) || {};
      var vendors = (rs[2].facets && rs[2].facets.vendor) || {};
      var marcas = Object.keys(vendors).sort(function (a, b) { return vendors[b] - vendors[a]; });
      if (grupoMarca.Marca && marcas.indexOf(grupoMarca.Marca) < 0) marcas.unshift(grupoMarca.Marca);
      var f = (rs[1].facets && rs[1].facets['options.talla']) || {};
      var valores = Object.keys(f).sort(ordenar);
      marcadas = marcadas.filter(function (v) { return valores.indexOf(v) >= 0; });
      lista.innerHTML = '';
      var faltan = []; // grupos que se ven y todavía no se eligieron
      if (marcas.length > (soloMarca ? 0 : 1)) {
        var cajaM = document.createElement('div');
        cajaM.className = 'madison-talla__grupo';
        cajaM.innerHTML = '<small class="madison-talla__gtit">Marca:</small>';
        var visibles = verTodasMarcas ? marcas : marcas.slice(0, 8);
        if (grupoMarca.Marca && visibles.indexOf(grupoMarca.Marca) < 0) visibles.push(grupoMarca.Marca);
        visibles.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'madison-talla__g' + (grupoMarca.Marca === v ? ' on' : '');
          b.setAttribute('data-grupo', 'Marca');
          b.setAttribute('data-valor', v);
          b.textContent = bonita(v);
          cajaM.appendChild(b);
        });
        if (!verTodasMarcas && marcas.length > visibles.length) {
          var mas = document.createElement('button');
          mas.type = 'button';
          mas.className = 'madison-talla__mas';
          mas.textContent = 'Ver más marcas (' + (marcas.length - visibles.length) + ')';
          cajaM.appendChild(mas);
        }
        lista.appendChild(cajaM);
      }
      // Solo marca (relojes, carteras, perfumes): sin Para/Tipo ni tallas. Perfumes: además Presentación (Decant / Frasco completo)
      if (soloMarca) {
        if (esPerfume && (etiquetas.Decant || grupoMarca['Presentación'])) {
          var cajaP = document.createElement('div');
          cajaP.className = 'madison-talla__grupo';
          cajaP.innerHTML = '<small class="madison-talla__gtit">Presentación:</small>';
          ['Decant', 'Frasco completo'].forEach(function (v) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'madison-talla__g' + (grupoMarca['Presentación'] === v ? ' on' : '');
            b.setAttribute('data-grupo', 'Presentación');
            b.setAttribute('data-valor', v);
            b.textContent = v;
            cajaP.appendChild(b);
          });
          lista.appendChild(cajaP);
        }
        contar();
        return;
      }
      GRUPOS.forEach(function (gr) {
        var hay = gr[1].filter(function (v) { return etiquetas[v] || grupoMarca[gr[0]] === v; });
        if (hay.length < 2 && !grupoMarca[gr[0]]) return; // si todo es de un solo grupo, no hace falta elegir
        if (!grupoMarca[gr[0]]) faltan.push(gr[0] === 'Para' ? 'para quién' : 'el tipo');
        var caja = document.createElement('div');
        caja.className = 'madison-talla__grupo';
        caja.innerHTML = '<small class="madison-talla__gtit"></small>';
        caja.firstChild.textContent = gr[0] + ':';
        hay.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'madison-talla__g' + (grupoMarca[gr[0]] === v ? ' on' : '');
          b.setAttribute('data-grupo', gr[0]);
          b.setAttribute('data-valor', v);
          b.textContent = v;
          caja.appendChild(b);
        });
        lista.appendChild(caja);
      });
      // 2026-10-09 (Jonathan): las tallas salen solo después de elegir Para y Tipo
      if (faltan.length) {
        var p1 = document.createElement('p');
        p1.className = 'madison-talla__vacio madison-talla__elige';
        p1.textContent = 'Selecciona las Opciones para mostrar'; // texto pedido por Jonathan 2026-10-10 (antes: "Elige para quién… para ver las tallas.")
        lista.appendChild(p1);
        contar();
        return;
      }
      if (!valores.length) {
        var p0 = document.createElement('p');
        p0.className = 'madison-talla__vacio';
        p0.textContent = 'No hay tallas en existencia para lo elegido.';
        lista.appendChild(p0);
      }
      valores.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'madison-talla__op' + (marcadas.indexOf(v) >= 0 ? ' on' : '');
        b.setAttribute('data-valor', v);
        b.innerHTML = '<span></span><small>(' + (f[v] || 0) + ')</small>';
        b.firstChild.textContent = v;
        lista.appendChild(b);
      });
      contar();
    }).catch(function () { if (n === pintando) lista.innerHTML = '<p class="madison-talla__vacio">No se pudieron cargar las tallas. Intenta de nuevo.</p>'; });
  }
  function cerrar() {
    if (!fondo) return;
    fondo.hidden = true;
    document.body.classList.remove('madison-talla-abierta');
  }
  function aplicar(tallas, g) {
    var h = helper();
    if (!h) return;
    elegidas = tallas;
    if (g) grupo = g;
    h.setPage(0).search();
    montar();
  }
  // Agrega las tallas elegidas a las consultas del buscador (índice de productos y sus formas de ordenar)
  function conectar() {
    var cliente = algoliaShopify.instantsearch.search.client;
    if (!cliente || cliente.madisonTallas) return;
    var original = cliente.search.bind(cliente);
    cliente.madisonTallas = true;
    cliente.search = function (pedidos) {
      var args = Array.prototype.slice.call(arguments);
      var partes = deGrupo(grupo);
      if (CAT) partes.unshift('collections:' + comillas(CAT));
      if (TF) partes.unshift(tiposTF());
      if (elegidas.length) partes.push('(' + elegidas.map(function (v) { return 'options.talla:' + comillas(v); }).join(' OR ') + ')');
      if (partes.length && Array.isArray(pedidos)) {
        var extra = partes.join(' AND ');
        args[0] = pedidos.map(function (r) {
          var p = r && r.params;
          if (!p || !r.indexName || r.indexName.indexOf('shopify_products') !== 0) return r;
          var nuevo = {}; for (var k in p) nuevo[k] = p[k];
          nuevo.filters = p.filters ? '(' + p.filters + ') AND ' + extra : extra;
          if ((CAT && catDe(p.query) === CAT) || (TF && tfDe(p.query))) nuevo.query = '';
          if (!soloMarca) nuevo.restrictSearchableAttributes = SOLO_EN;
          nuevo.typoTolerance = 'min';
          var r2 = {}; for (var j in r) r2[j] = r[j];
          r2.params = nuevo;
          return r2;
        });
      }
      return original.apply(null, args);
    };
  }

  // Botón al lado de "Ordenar por" y etiquetas de las tallas elegidas
  function montar() {
    var barra = document.querySelector('.madison-busqueda__barra');
    var h = helper();
    if (!barra || !h) return;
    var nGrupo = deGrupo(grupo).length;
    var mostrar = hayRopa || soloMarca || elegidas.length > 0 || nGrupo > 0;
    var bloque = barra.parentNode, cab = document.querySelector('.madison-busqueda__cabecera');
    barra.classList.toggle('madison-con-talla', mostrar);
    bloque.classList.toggle('madison-con-talla', mostrar);
    if (cab) cab.classList.toggle('madison-con-talla', mostrar);
    var caja = barra.querySelector('.madison-talla');
    if (!mostrar) { if (caja) caja.remove(); var c0 = document.querySelector('.madison-talla__chips'); if (c0) c0.remove(); return; }
    if (!caja) {
      caja = document.createElement('div');
      caja.className = 'madison-talla';
      caja.innerHTML = '<button type="button" class="madison-talla__boton"><span class="madison-talla__nombre">Filtrar por</span> <span class="madison-talla__extra"></span></button>';
      caja.firstChild.addEventListener('click', abrir);
      var orden = barra.querySelector('.madison-busqueda__orden');
      if (orden) orden.insertAdjacentElement('afterend', caja); else barra.appendChild(caja);
    }
    caja.querySelector('.madison-talla__nombre').textContent = soloMarca && !hayRopa && !esPerfume ? 'Filtrar por marca' : 'Filtrar por';
    var extra = caja.querySelector('.madison-talla__extra');
    if (elegidas.length + nGrupo) { extra.className = 'madison-talla__extra madison-talla__num'; extra.textContent = elegidas.length + nGrupo; }
    else { extra.className = 'madison-talla__extra'; extra.innerHTML = '<svg class="madison-chevron" viewBox="0 0 12 8" width="12" height="8" aria-hidden="true"><path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path></svg>'; }

    var chips = document.querySelector('.madison-talla__chips');
    var clave = elegidas.join('|') + '#' + claveG(grupo);
    if (chips && chips.getAttribute('data-clave') === clave) return;
    if (chips) chips.remove();
    if (!elegidas.length && !nGrupo) return;
    chips = document.createElement('div');
    chips.className = 'madison-talla__chips';
    chips.setAttribute('data-clave', clave);
    CLAVES.forEach(function (k) {
      if (!grupo[k]) return;
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'madison-talla__chip';
      a.innerHTML = '<b></b> <span>&times;</span>';
      a.firstChild.textContent = k === 'Marca' ? bonita(grupo[k]) : grupo[k];
      a.addEventListener('click', function () { var g2 = copia(grupo); g2[k] = ''; aplicar(elegidas, g2); });
      chips.appendChild(a);
    });
    elegidas.forEach(function (v) {
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'madison-talla__chip';
      a.innerHTML = '<b></b> <span>&times;</span>';
      a.firstChild.textContent = 'Talla ' + v;
      a.addEventListener('click', function () { aplicar(elegidas.filter(function (x) { return x !== v; })); });
      chips.appendChild(a);
    });
    var limpiar = document.createElement('button');
    limpiar.type = 'button';
    limpiar.className = 'madison-talla__limpiar';
    limpiar.textContent = 'Limpiar';
    limpiar.addEventListener('click', function () { aplicar([], copia(VACIO)); });
    chips.appendChild(limpiar);
    barra.insertAdjacentElement('afterend', chips);
  }

  // Cuando cambia lo buscado: revisar si hay ropa o calzado (y borrar las tallas elegidas de la búsqueda anterior)
  function revisar() {
    var h = helper();
    if (!h) return;
    var q = h.state.query || '';
    if (q !== ultimaConsulta) {
      var cambio = ultimaConsulta !== null;
      ultimaConsulta = q;
      var catNueva = catDe(q), tfNuevo = tfDe(q);
      if (cambio && (CAT !== catNueva || String(TF) !== String(tfNuevo))) { CAT = catNueva; TF = tfNuevo; soloMarca = Boolean(TF); esPerfume = Boolean(TF && TF.indexOf('Perfumes') >= 0); elegidas = []; grupo = copia(VACIO); h.search(); }
      else if (cambio && (elegidas.length || deGrupo(grupo).length)) { elegidas = []; grupo = copia(VACIO); h.search(); }
      consultar([], true).then(function (r) {
        if ((h.state.query || '') !== q) return;
        // Igual que en las categorías: solo si al menos la MITAD de lo encontrado es "Ropa Y Calzados"
        var tipos = (r.facets && r.facets.product_type) || {};
        var suma = Object.keys(tipos).reduce(function (t, k) { return t + tipos[k]; }, 0);
        hayRopa = suma > 0 && (tipos[TIPO] || 0) * 2 >= suma;
        var deMarca = TIPOS_MARCA.reduce(function (t, k) { return t + (tipos[k] || 0); }, 0);
        soloMarca = Boolean(TF) || (!hayRopa && suma > 0 && deMarca * 2 >= suma);
        esPerfume = (TF ? TF.indexOf('Perfumes') >= 0 : false) || (!hayRopa && suma > 0 && (tipos.Perfumes || 0) * 2 >= suma);
        montar();
      }).catch(function () {});
    }
    montar();
  }
  var intentos = 0;
  (function esperar() {
    var h = helper();
    if (h && document.querySelector('.madison-busqueda__barra')) {
      conectar();
      if (TF) { soloMarca = true; esPerfume = TF.indexOf('Perfumes') >= 0; }
      if (CAT || TF) h.search(); // la primera búsqueda salió sin la categoría
      h.on('result', function () { setTimeout(revisar, 0); });
      revisar();
      return;
    }
    if (intentos++ < 100) setTimeout(esperar, 100);
  })();
})();

// Madison 2026-10-08: "Ordenar por" del buscador (Algolia) con la cajita de las categorías: sale a la izquierda, debajo del
// botón, con la opción elegida en azul. Las opciones son las del <select> de Algolia (ya con nuestros nombres); al tocar
// una se cambia el <select> y Algolia ordena.
(function () {
  if (!/\/search/.test(location.pathname)) return;
  var menu, abiertaEn = 0;
  function crear() {
    menu = document.createElement('div');
    menu.className = 'madison-cant madison-pop madison-pop--orden';
    menu.hidden = true;
    menu.innerHTML = '<div class="madison-cant__caja madison-pop__caja" role="dialog" aria-label="Ordenar por"><div class="madison-pop__titulo">Ordenar por:</div><ul class="madison-cant__lista madison-pop__lista"></ul></div>';
    menu.addEventListener('click', function (e) {
      if (Date.now() - abiertaEn < 450) return; // el mismo toque que abre no debe elegir (iPhone)
      if (e.target === menu) { menu.hidden = true; return; }
      var li = e.target.closest('[data-valor]');
      if (!li) return;
      menu.hidden = true;
      var v = li.getAttribute('data-valor');
      var h = null;
      try { h = algoliaShopify.instantsearch.search.helper; } catch (er) {}
      // 2026-10-09: se cambia el índice directo en Algolia (las opciones nuevas no las conoce el <select> de Algolia)
      if (h) { if (h.state.index !== v) h.setIndex(v).setPage(0).search(); }
      else {
        var sel = document.querySelector('.madison-busqueda__orden select');
        if (!sel || sel.value === v) return;
        sel.value = v;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    // Que los toques en la cajita no le lleguen al buscador (cerraría los resultados creyendo que se tocó afuera)
    ['mousedown', 'touchstart', 'pointerdown'].forEach(function (t) { menu.addEventListener(t, function (e) { e.stopPropagation(); }); });
    document.body.appendChild(menu);
  }
  function abrir(boton) {
    var sel = boton.querySelector('select');
    if (!sel) return;
    if (!menu) crear();
    var ul = menu.querySelector('ul');
    ul.textContent = '';
    var actual = sel.value;
    try { actual = algoliaShopify.instantsearch.search.helper.state.index || actual; } catch (er) {}
    Array.prototype.forEach.call(sel.options, function (o) {
      var li = document.createElement('li');
      li.setAttribute('data-valor', o.value);
      if (o.value === actual) li.className = 'is-actual';
      var t = document.createElement('span');
      t.textContent = o.textContent;
      li.appendChild(t);
      ul.appendChild(li);
    });
    abiertaEn = Date.now();
    menu.hidden = false;
    var caja = menu.querySelector('.madison-cant__caja');
    var r = boton.getBoundingClientRect();
    caja.style.top = Math.max(8, Math.min(r.bottom + 8, window.innerHeight - caja.offsetHeight - 12)) + 'px';
    // 2026-10-09: el botón redondo está arriba a la derecha (junto a las vistas): la cajita va pegada al borde DERECHO
    caja.style.left = (r.left > window.innerWidth / 2 ? Math.max(10, document.documentElement.clientWidth - caja.offsetWidth - 10) : 10) + 'px';
  }
  document.addEventListener('click', function (e) {
    var boton = e.target.closest && e.target.closest('.madison-busqueda__orden');
    if (!boton) return;
    e.preventDefault();
    abrir(boton);
  });
  // 2026-10-09: al ordenar por nombre o precio, Algolia pone primero coincidencias "parecidas" baratas ("nike" ≈ "nivea":
  // grapadora, desodorantes). En esos órdenes se le pide ser estricto (typoTolerance "min"): si hay coincidencias exactas,
  // solo esas. En "Destacados" no se toca (ahí ya ordena por parecido).
  var intentos = 0;
  (function esperar() {
    var cliente = null;
    try { cliente = algoliaShopify.instantsearch.search.client; } catch (er) {}
    if (!cliente) { if (intentos++ < 100) setTimeout(esperar, 100); return; }
    if (cliente.madisonOrden) return;
    cliente.madisonOrden = true;
    var original = cliente.search.bind(cliente);
    cliente.search = function (pedidos) {
      var args = Array.prototype.slice.call(arguments);
      if (Array.isArray(pedidos)) {
        args[0] = pedidos.map(function (r) {
          if (!r || !r.params || !/_(title|price)_(asc|desc)$/.test(r.indexName || '')) return r;
          var nuevo = {}; for (var k in r.params) nuevo[k] = r.params[k];
          nuevo.typoTolerance = 'min';
          var r2 = {}; for (var j in r) r2[j] = r[j];
          r2.params = nuevo;
          return r2;
        });
      }
      return original.apply(null, args);
    };
  })();
})();

// Madison 2026-10-08: "Ordenar por" de TODAS las categorías con la cajita (a la izquierda, debajo del botón, elegida en azul)
// y solo 5 opciones: Destacados, A-Z, Z-A, precio menor a mayor y mayor a menor (pedido de Jonathan). Antes solo Ropa y
// Calzado la tenía (sections/madison-filtro-talla.liquid); esta la reemplaza en todas. Al tocar una opción se le pasa el
// toque a la opción del tema, que es quien ordena.
(function () {
  var FUERA = ['most-relevant', 'best-selling', 'created-ascending', 'created-descending'];
  var menu, abiertaEn = 0;
  function crear() {
    menu = document.createElement('div');
    menu.className = 'madison-cant madison-pop madison-pop--orden madison-pop--orden-tema';
    menu.hidden = true;
    menu.innerHTML = '<div class="madison-cant__caja madison-pop__caja" role="dialog" aria-label="Ordenar por"><div class="madison-pop__titulo">Ordenar por:</div><ul class="madison-cant__lista madison-pop__lista"></ul></div>';
    menu.addEventListener('click', function (e) {
      if (Date.now() - abiertaEn < 450) return; // el mismo toque que abre no debe elegir (iPhone)
      if (e.target === menu) { menu.hidden = true; return; }
      var li = e.target.closest('[data-valor]');
      if (!li) return;
      menu.hidden = true;
      var op = document.querySelector('#sort-by-selector [data-value="' + li.getAttribute('data-valor') + '"]');
      if (op && !op.classList.contains('is-selected')) op.click();
    });
    document.body.appendChild(menu);
  }
  document.addEventListener('click', function (e) {
    var boton = e.target.closest && e.target.closest('.collection__toolbar-item--sort .value-picker-button');
    if (!boton || !document.getElementById('sort-by-selector')) return;
    e.preventDefault();
    e.stopPropagation(); // que el tema no abra su ventana de abajo
    if (!menu) crear();
    var ul = menu.querySelector('ul');
    ul.textContent = '';
    Array.prototype.forEach.call(document.querySelectorAll('#sort-by-selector .value-picker__choice-item'), function (op) {
      var valor = op.getAttribute('data-value');
      if (FUERA.indexOf(valor) >= 0) return;
      var li = document.createElement('li');
      li.setAttribute('data-valor', valor);
      if (op.classList.contains('is-selected')) li.className = 'is-actual';
      var t = document.createElement('span');
      t.textContent = valor === 'manual' ? 'Destacados' : op.textContent.trim();
      li.appendChild(t);
      ul.appendChild(li);
    });
    abiertaEn = Date.now();
    menu.hidden = false;
    var caja = menu.querySelector('.madison-cant__caja');
    var r = boton.getBoundingClientRect();
    caja.style.top = Math.max(8, Math.min(r.bottom + 8, window.innerHeight - caja.offsetHeight - 12)) + 'px';
    // Si el botón está a la derecha (botón redondo junto a las vistas), la cajita va pegada al borde DERECHO de la pantalla
    // (pedido de Jonathan); si no, a la izquierda
    caja.style.left = (r.left > window.innerWidth / 2 ? Math.max(10, document.documentElement.clientWidth - caja.offsetWidth - 10) : 10) + 'px';
  }, true);
})();

// Madison 2026-10-10 (Ajustes 13): corazón de Favoritos en el encabezado del celular, a la izquierda de la cuenta
// (2026-10-11: lleva a la página Mis favoritos /pages/favoritos, sin pedir sesión). Se muestra solo en celular (madison-guardados.css).
(function () {
  function poner() {
    var cuenta = document.querySelector('.header__action-item--account');
    if (!cuenta || document.querySelector('.header__action-item--favoritos')) return;
    var d = document.createElement('div');
    d.className = 'header__action-item header__action-item--favoritos';
    d.innerHTML = '<a class="header__action-item-link" href="/pages/favoritos" aria-label="Favoritos">' +
      '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M12 20.5s-7.5-4.6-7.5-10.3A4.3 4.3 0 0 1 12 7.4a4.3 4.3 0 0 1 7.5 2.8c0 5.7-7.5 10.3-7.5 10.3z"/></svg>' +
      '<span class="madison-fav-texto">Favoritos</span></a>';
    cuenta.parentNode.insertBefore(d, cuenta);
  }
  // Con sesión iniciada, el NOMBRE (debajo del ícono de cuenta) debe terminar a 10px del borde, igual que las 3 rayitas
  // a la izquierda (Jonathan). Cada nombre mide distinto: se mide y se corre la cuenta (y el corazón) lo necesario.
  function margenNombre() {
    if (window.innerWidth > 999) return;
    var it = document.querySelector('.header__action-item--account');
    var n = it && it.querySelector('.madison-hola');
    var ic = it && it.querySelector('svg');
    if (!n || !ic) return;
    it.style.removeProperty('margin-right');
    var sobra = Math.max(0, n.getBoundingClientRect().right - ic.getBoundingClientRect().right);
    it.style.setProperty('margin-right', (-15 + sobra) + 'px', 'important');
  }
  // "Mis favoritos" del menú ☰ (snippets/mobile-menu.liquid) también va a la página nueva, sin pedir sesión
  function enlacesFavoritos() {
    Array.prototype.forEach.call(document.querySelectorAll('a[href$="/account#favoritos"]'), function (a) {
      a.setAttribute('href', '/pages/favoritos');
    });
  }
  function todo() { poner(); margenNombre(); enlacesFavoritos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
  window.addEventListener('load', margenNombre);
  window.addEventListener('resize', margenNombre);
})();

// Madison 2026-10-10 (Ajustes 13): en los resultados del buscador (Algolia) la etiqueta "Entrega en 90 min" se cambia por
// las etiquetas [Delivery Gratis] [Cashea] y "⚡ 90 min · +$20", igual que en las categorías (snippets/madison-entrega-90.liquid).
(function () {
  if (!/\/search/.test(location.pathname)) return;
  var CASHEA = 'https://madisoncenter.com/cdn/shop/files/cashea-logo-main.jpg?width=200';
  var NUEVO = '<div class="madison-entrega-lista">' +
    '<div class="madison-entrega-lista__fila"><span class="madison-entrega-lista__delivery">' +
    '<svg width="18" height="13" viewBox="0 0 28 20" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2 3h14v10H2zM16 7h5l3 3v3h-8"/><circle cx="7" cy="15.5" r="2.2"/><circle cx="20" cy="15.5" r="2.2"/></svg>' +
    'Delivery Gratis</span><img class="madison-entrega-lista__cashea" src="' + CASHEA + '" alt="Cashea" width="88" height="22" loading="lazy"></div>' +
    '<div class="madison-entrega-lista__tiempo"><svg width="10" height="12" viewBox="0 0 11 13" aria-hidden="true" focusable="false"><path d="M6.6 0 0.8 7.3h3.9L3.9 13l6.3-7.6H6.2L6.6 0z" fill="#FDC441"/></svg>' +
    '<span><strong style="font-weight: 800;">90 min</strong> · +$20</span></div></div>';
  function cambiar() {
    document.querySelectorAll('.ais-Hits-item .madison-entrega').forEach(function (e) {
      var agotado = /visibility:\s*hidden/.test(e.getAttribute('style') || '');
      var d = document.createElement('div');
      d.innerHTML = NUEVO;
      var n = d.firstChild;
      if (agotado) { n.setAttribute('aria-hidden', 'true'); n.style.visibility = 'hidden'; }
      e.replaceWith(n);
    });
  }
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(cambiar, 30); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') cambiar(); else document.addEventListener('DOMContentLoaded', cambiar);
})();

// Madison 2026-10-12 (diseño de Jonathan): recuadro de entrega de la ficha del celular (lo arma snippets/madison-ficha-movil.liquid).
// Lado izquierdo: "Delivery Gratis" (grande, azul) / "En compras mayores a $20" / "Caracas · En 90 min ⚡".
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var intentos = 0;
  function cambiar() {
    var txt = document.querySelector('.mf-entrega .mf-entrega__lado:first-child .mf-entrega__txt');
    if (!txt) { if (intentos++ < 20) setTimeout(cambiar, 150); return; }
    if (txt.classList.contains('mf-entrega__txt--nuevo')) return;
    txt.classList.add('mf-entrega__txt--nuevo');
    // Ajustes 22 (diseño de Jonathan 2026-10-25): "Delivery Gratis" / "En compras desde $20"
    txt.innerHTML = '<span class="mf-ent-titulo">Delivery Gratis</span>' +
      '<span class="mf-ent-monto">En compras desde $20</span>' +
      '<span class="mf-ent-lugar">Caracas · <em>En 90 min</em>' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13.5 2L5 13.5h6L9.5 22 19 9.5h-6.2z" fill="#F5B400"/></svg></span>';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(cambiar, 0); }); else setTimeout(cambiar, 0);
})();

